import p5 from "p5";
import EventEmitter from "./EventEmitter";

export let p5Width;
export let p5Height;


// This function initializes and returns the p5 instance.
export function generateTexture(container1, container2) {
  return new Promise((resolve) => {

    // variables:

    // Variables to track when drawing is complete
    let p5InstanceReady = false;
    let p5Instance2Ready = false;

    // Variables to store p5 instances
    let p5Instance, p5Instance2;

    // Function to check if both instances are ready
    const checkIfReady = () => {
      if (p5InstanceReady && p5Instance2Ready) {
        resolve({ p5Instance, p5Instance2 });
      }
    };

    let scale = 10

    p5Width = 7087 / scale
    p5Height = 7087 / scale

    //sketch:

    p5Instance = new p5((sketch) => {

      // colours:
      let purple_colour = "#670099";
      let blue_colour = "#3e51ff";
      let pink_colour = "hotpink";
      let turq_colour = "aqua";
      let orange_colour = "#FF4500";
      let brown_colour = "#640045";
      let yellow_colour = "#f5bf00";
      let white_colour = "white";
      let age_colour = [blue_colour, pink_colour, turq_colour, orange_colour, purple_colour, yellow_colour, brown_colour]; // remove brown..
      let age_colour2 = [blue_colour, pink_colour, turq_colour, orange_colour, purple_colour, yellow_colour];

      let data_categories = ["age", "gender", "eye colour", "music", "free time", "compliment", "intro extro", "reckless cautious", "superpower", "personality", "cooking skills", "commute", "fear", "memory", "time travel", "proud", "mind"];

      // Rotations:
      let rotate90 = 0;
      let rotate90_2 = 0;
      let flip = 1;
      let flip_2 = -1;

      // Counters:
      let counter = 0;
      let sequenceCounter = 0;
      let charCounter = 0;
      let splitCounter = 0;

      let splitCounter_4x4 = 0;
      let splitCounter_3x3 = 0;
      let splitCounter_2x2 = 0;
      let splitCounter_1x1 = 0;

      // String Variables
      let colourChoice_01;
      let colourChoice_02;
      let selectString;

      let howMany;
      let five_choices_divide = [2, 1, 1, 1];
      let six_choices_divide = [2, 2, 1, 1];
      let nine_choices_divide = [3, 2, 2, 2];

      const gen_choices = ["Male", "Female", "Non-binary", "Other"];
      const eye_choices = ["Brown", "Blue", "Hazel", "Amber", "Grey", "Green", "Heterochromatic"];
      const music_choices = ["Acoustic", "Afro", "Blues", "Breakbeat", "Gospel", "Classical", "Country", "Dance / electronic", "Disco", "Drum & bass", "Folk", "Funk", "Hiphop", "Indie", "Jazz", "K-pop", "Latin", "Metal", "Pop", "Punk", "Reggae", "Rnb", "Rock", "Salsa", "Soul", "Techno", "Traditional", "Other"];
      const time_choices = ["Being social with friends / family", "Creative hobby / practice", "Cultural activities", "Gaming", "Reading", "Sleeping", "Sports / exercise", "Watching series / television", "I don't have any free time. I just work", "Other"];
      const intro_extro_choices = ["Introvert", "Lightly introvert", "Ambivert", "Lightly extrovert", "Extrovert"];
      const reck_caut_choices = ["Highly reckless", "Quite reckless", "Bit of both", "Quite cautious", "Extremely cautious"];
      const thisyear_choices = ["Extremely poor", "Bad", "Decent", "Good", "Excellent"];
      const commute_choices = ["Bike", "Car", "Public transport", "Walk", "Motorcycle", "Motor scooter", "Uber / taxi", "Mobility aid", "Skate", "Other"];
      const time_travel_choices = ["To the future", "To the past", "Stay here"];

      // for age grid
      let myAge = 1;
      let mySequence = 0;

      let Xl;
      let Xb;

      let myB = [];
      let myA = [];
      let myXb = [];
      let myXl = [];

      let responsiveness = [
        { res: "1x1", value: 1 },
        { res: "2x2", value: 4 },
        { res: "3x3", value: 9 },
        { res: "4x4", value: 16 },
      ];

      let input_data = {
        first_name: "",
        last_name: "",
        age: 0,
        gender: "",
        gender_selfdescribe: "",
        eye_colour: "",
        music: "",
        music_selfdescribe: "",
        living: "",
        time: "",
        time_selfdescribe: "",
        compliment: "",
        intro_extro: "",
        reck_caut: "",
        superpower: "",
        personality: "",
        thisyear: "",
        commute: "",
        commute_selfdescribe: "",
        fear: "",
        memory: "",
        time_travel: "",
        proud: "",
      };

      sketch.resetData = () => {
        // Rotations:
        rotate90 = 0;
        rotate90_2 = 0;
        flip = 1;
        flip_2 = -1;

        // Counters:
        counter = 0;
        sequenceCounter = 0;
        charCounter = 0;
        splitCounter = 0;

        splitCounter_4x4 = 0;
        splitCounter_3x3 = 0;
        splitCounter_2x2 = 0;
        splitCounter_1x1 = 0;

        // String Variables
        colourChoice_01;
        colourChoice_02;
        selectString;

        // for age grid
        myAge = 1;
        mySequence = 0;

        myB = [];
        myA = [];
        myXb = [];
        myXl = [];
      }

      let grotesk;
      let montreal;

      sketch.preload = () => {
        grotesk = sketch.loadFont("/fonts/NonNaturalGrotesk-Bold.otf");
        montreal = sketch.loadFont('/fonts/PPNeueMontreal-Medium.otf')
      }


      sketch.setup = () => {

        sketch.createCanvas(p5Width, p5Height); //90x150cm
        //sketch.background(255, 255, 240);
        sketch.background(brown_colour)
        sketch.noLoop()

      }

      sketch.draw = () => {

        sketch.resetData();
        sketch.background(brown_colour);
        //sketch.frameRate(15)
        sketch.noStroke();
        sketch.noFill();

        let amountOfStrokes = 17; // amount of fields 17
        let amountOfBoxesWithinSmallest = 12; // default is 6
        let amountOfBoxesWithinBorder = 3;
        let totalAmountOfBoxes = (amountOfStrokes - 1) * 2 + amountOfBoxesWithinSmallest + amountOfBoxesWithinBorder * 2;
      
        let gridBoxSize = sketch.height / totalAmountOfBoxes;
      
        let myBorder = amountOfBoxesWithinBorder * gridBoxSize;
        let smallest = amountOfBoxesWithinSmallest * gridBoxSize; // field
        let biggest = sketch.height - myBorder * 2;
      
        // All gradients
      
        let gradient_purple_pink = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_purple_pink.addColorStop(0, sketch.color(purple_colour));
        gradient_purple_pink.addColorStop(1, sketch.color(pink_colour));
      
        let gradient_purple_turq = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_purple_turq.addColorStop(0, sketch.color(purple_colour));
        gradient_purple_turq.addColorStop(1, sketch.color(turq_colour));
      
        let gradient_yellow_turq = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_yellow_turq.addColorStop(0, sketch.color(yellow_colour));
        gradient_yellow_turq.addColorStop(1, sketch.color(turq_colour));
      
        let gradient_yellow_white = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_yellow_white.addColorStop(0, sketch.color(yellow_colour));
        gradient_yellow_white.addColorStop(1, sketch.color(white_colour));
      
        let gradient_pink_white = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_pink_white.addColorStop(0, sketch.color(pink_colour));
        gradient_pink_white.addColorStop(1, sketch.color(white_colour));
      
        let gradient_purple_white = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_purple_white.addColorStop(0, sketch.color(purple_colour));
        gradient_purple_white.addColorStop(1, sketch.color(white_colour));
      
        let gradient_blue_white = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_blue_white.addColorStop(0, sketch.color(blue_colour));
        gradient_blue_white.addColorStop(1, sketch.color(white_colour));
      
        let gradient_turq_white = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_turq_white.addColorStop(0, sketch.color(turq_colour));
        gradient_turq_white.addColorStop(1, sketch.color(white_colour));
      
        let gradient_orange_white = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_orange_white.addColorStop(0, sketch.color(orange_colour));
        gradient_orange_white.addColorStop(1, sketch.color(white_colour));
      
        let gradient_blue_turq = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_blue_turq.addColorStop(0, sketch.color(blue_colour));
        gradient_blue_turq.addColorStop(1, sketch.color(turq_colour));
      
        let gradient_blue_pink = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_blue_pink.addColorStop(0, sketch.color(blue_colour));
        gradient_blue_pink.addColorStop(1, sketch.color(pink_colour));
      
        let gradient_pink_blue = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_pink_blue.addColorStop(0, sketch.color(pink_colour));
        gradient_pink_blue.addColorStop(1, sketch.color(blue_colour));
      
        let gradient_blue_brown = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_blue_brown.addColorStop(0, sketch.color(blue_colour));
        gradient_blue_brown.addColorStop(1, sketch.color(brown_colour));
      
        let gradient_yellow_pink = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_yellow_pink.addColorStop(0, sketch.color(yellow_colour));
        gradient_yellow_pink.addColorStop(1, sketch.color(pink_colour));
      
        let gradient_yellow_orange = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_yellow_orange.addColorStop(0, sketch.color(yellow_colour));
        gradient_yellow_orange.addColorStop(1, sketch.color(orange_colour));
      
        let gradient_yellow_brown = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_yellow_brown.addColorStop(0, sketch.color(brown_colour));
        gradient_yellow_brown.addColorStop(1, sketch.color(yellow_colour));
      
        let gradient_turq_brown = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_turq_brown.addColorStop(0, sketch.color(brown_colour));
        gradient_turq_brown.addColorStop(1, sketch.color(turq_colour));
      
        let gradient_pink_brown = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_pink_brown.addColorStop(0, sketch.color(brown_colour));
        gradient_pink_brown.addColorStop(1, sketch.color(pink_colour));
      
        let gradient_orange_brown = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_orange_brown.addColorStop(0, sketch.color(brown_colour));
        gradient_orange_brown.addColorStop(1, sketch.color(orange_colour));
      
        let gradient_orange_pink = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_orange_pink.addColorStop(0, sketch.color(pink_colour));
        gradient_orange_pink.addColorStop(1, sketch.color(orange_colour));
      
        let gradient_pink_turq = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_pink_turq.addColorStop(0, sketch.color(turq_colour));
        gradient_pink_turq.addColorStop(1, sketch.color(pink_colour));
      
        let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
        gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));
      
        let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - gridBoxSize / 2, 0, 0 + gridBoxSize / 2, 0);
      
        gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
        gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));
      
        sketch.rectMode(sketch.CENTER);
        sketch.angleMode(sketch.DEGREES);
        sketch.noFill();
      
        sketch.textAlign(sketch.CENTER, sketch.TOP);
        sketch.fill(pink_colour);
        sketch.textSize(gridBoxSize * 1.2);
        sketch.textLeading();
        sketch.textFont(grotesk);
      
        for (let placeTextInBorder = 0; placeTextInBorder < 4; placeTextInBorder++) {
          sketch.push();
          sketch.translate(sketch.width / 2, sketch.height / 2);
          sketch.rotate(90 * placeTextInBorder);
      
          sketch.text("antoia                                {" + sketch.getFirstLetters(input_data.first_name, input_data.last_name) + "}", 0, 0 - biggest / 2 - gridBoxSize, sketch.width, gridBoxSize * 2);
          sketch.pop();
        }
      
        sketch.textFont(montreal);
        sketch.textAlign(sketch.CENTER, sketch.CENTER);
        //fill(white_colour)
        sketch.text("•THE LABYRINTH• \n your new scarf awaits", sketch.width / 2, sketch.height / 2, sketch.width / 4, sketch.height / 4);
      
        sketch.noStroke();

  // draw fields
  for (let i = 0; i <= amountOfStrokes - 1; i++) {
    let myRectSize = biggest - 2 * gridBoxSize * i;
    let placeXYminus = sketch.width / 2 - 0.5 * myRectSize; // + 0.5 * gridBoxSize
    let placeXYplus = sketch.width / 2 + 0.5 * myRectSize; // 0.5 * gridBoxSize
    let aantalVakjes = myRectSize / gridBoxSize;

    // write content, inside-out:

    switch (i) {
      case 16:
        {
          // AGE
          // possible answers: all round numbers 1+

          sketch.push();

          // Option 01: flexible size / always sketch.fills field
          calculateScale: for (let a = 1; a <= input_data.age; a++) {
            let b = input_data.age / a;

            if (b >= a && a % 1 === 0 && b % 1 === 0) {
              myXb.push(myRectSize / b);
              myXl.push(myRectSize / a);
            }
          }

          const distanceX = myXb[myXb.length - 1];
          const distanceY = myXl[myXl.length - 1];

          // don't edit these
          const gridX = distanceX / 2; //don't edit
          const gridY = distanceY / 2; //don't edit

          let startHere = sketch.width / 2 - smallest / 2;
          let stopHere = sketch.width / 2 + smallest / 2;

          drawAge: for (let y = startHere + gridY; y <= stopHere - gridY / 2; y += distanceY) {
            for (let x = startHere + gridX; x <= stopHere - gridX / 2; x += distanceX) {
              if (myAge > input_data.age) {
                break drawAge;
                // !!!! add additional system for entries below 1? for babies, divide the whole block in 12 segments, one for each month.
              }

              //sketch.fill(random(pickColour)) // !!!! colours should have a sequence, so colours are never repeated next to each other.

              if (input_data.age % 7 === 0 && input_data.age !== 84) {
                sketch.fill(age_colour2[mySequence]);

                sketch.rect(x, y, distanceX, distanceY);
                sketch.noStroke();
                myAge++;

                mySequence++;
                if (mySequence > age_colour2.length - 1) {
                  mySequence = 0;
                }
              } else {
                sketch.fill(age_colour[mySequence]);

                sketch.rect(x, y, distanceX, distanceY);
                sketch.noStroke();
                myAge++;

                mySequence++;
                if (mySequence > age_colour.length - 1) {
                  mySequence = 0;
                }
              }
            }
          }

          sketch.pop();
        }

        break;
      case 15:
        {
          // GENDER

          switch (input_data.gender) {
            case gen_choices[0]:
              {
                // 'MALE'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(purple_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(blue_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(blue_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }
              }
              break;
            case gen_choices[1]:
              {
                // 'FEMALE'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(purple_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(pink_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(pink_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }
              }
              break;
            case gen_choices[2]:
              {
                // 'NON-BINARY'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(purple_colour);
                    // sketch.drawingContext.fillStyle = gradient_orange_pink;
                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  } else {
                    sketch.fill(purple_colour);
                    //sketch.drawingContext.fillStyle = gradient_orange_pink;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  }
                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(purple_colour);
                    //sketch.drawingContext.fillStyle = gradient_orange_pink;
                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  } else {
                    sketch.fill(purple_colour);
                    //sketch.drawingContext.fillStyle = gradient_orange_pink;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  }
                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(purple_colour);
                    //sketch.drawingContext.fillStyle = gradient_orange_pink;
                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  } else {
                    sketch.fill(purple_colour);
                    //sketch.drawingContext.fillStyle = gradient_orange_pink;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  }
                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(purple_colour);
                    //sketch.drawingContext.fillStyle = gradient_orange_pink;
                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  } else {
                    sketch.fill(purple_colour);
                    //sketch.drawingContext.fillStyle = gradient_orange_pink;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  }
                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                sequenceCounter = 0;
                counter = 0;
              }
              break;
            case gen_choices[3]:
              {
                // 'OTHER'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);
                    sketch.fill(turq_colour);
                    sketch.scale(-1, 1);
                    // sketch.drawingContext.fillStyle = gradient_yellow_orange;
                  } else {
                    sketch.fill(turq_colour);
                    //    sketch.drawingContext.fillStyle = gradient_yellow_orange;
                    sketch.rect(0, -gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);
                    sketch.fill(brown_colour);
                  }

                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);
                    sketch.fill(turq_colour);
                    sketch.scale(-1, 1);
                    //  sketch.drawingContext.fillStyle = gradient_yellow_orange;
                  } else {
                    sketch.fill(turq_colour);
                    // sketch.drawingContext.fillStyle = gradient_yellow_orange;
                    sketch.rect(0, -gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);
                    sketch.fill(brown_colour);
                  }

                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }
                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);
                    sketch.fill(turq_colour);
                    sketch.scale(-1, 1);
                    //  sketch.drawingContext.fillStyle = gradient_yellow_orange;
                  } else {
                    sketch.fill(turq_colour);
                    //  sketch.drawingContext.fillStyle = gradient_yellow_orange;
                    sketch.rect(0, -gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);
                    sketch.fill(brown_colour);
                  }

                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);
                    sketch.fill(turq_colour);
                    sketch.scale(-1, 1);
                    //  sketch.drawingContext.fillStyle = gradient_yellow_orange;
                  } else {
                    sketch.fill(turq_colour);
                    //     sketch.drawingContext.fillStyle = gradient_yellow_orange;
                    sketch.rect(0, -gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);
                    sketch.fill(brown_colour);
                  }

                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
              }
              break;
          }
        }
        break;
      case 14:
        {
          // EYE COLOUR

          switch (input_data.eye_colour) {
            case eye_choices[0]:
              {
                // 'BROWN'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.drawingContext.fillStyle = gradient_orange_blue;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                    sketch.fill(orange_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize / 3, gridBoxSize / 3, 270, 90);
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.drawingContext.fillStyle = gradient_orange_blue;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                    sketch.fill(orange_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize / 3, gridBoxSize / 3, 270, 90);
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.drawingContext.fillStyle = gradient_orange_blue;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                    sketch.fill(orange_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize / 3, gridBoxSize / 3, 270, 90);
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.drawingContext.fillStyle = gradient_orange_blue;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                    sketch.fill(orange_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize / 3, gridBoxSize / 3, 270, 90);
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }
                counter = 0;
              }

              break;
            case eye_choices[1]:
              {
                // 'BLUE'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case eye_choices[2]:
              {
                // 'HAZEL'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                    // sketch.pop();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                    // sketch.pop();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                    // sketch.pop();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                    // sketch.pop();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
              }
              break;
            case eye_choices[3]:
              {
                // 'AMBER'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.scale(flip, 1);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.rect(gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                    sketch.pop();

                    flip = -1;
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.rect(gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                    flip = 1;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }
                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.scale(flip, 1);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.rect(gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                    sketch.pop();

                    flip = -1;
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.rect(gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                    flip = 1;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.scale(flip, 1);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.rect(gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                    sketch.pop();

                    flip = -1;
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.rect(gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                    flip = 1;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }

                counter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.scale(flip, 1);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.rect(gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                    sketch.pop();

                    flip = -1;
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.rect(gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                    flip = 1;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }
              }

              break;
            case eye_choices[4]:
              {
                // 'GREY'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(pink_colour);
                  sketch.drawingContext.fillStyle = gradient_pink_yellow;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 315, 135);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.fill(pink_colour);
                  sketch.drawingContext.fillStyle = gradient_pink_yellow;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 315, 135);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.fill(pink_colour);
                  sketch.drawingContext.fillStyle = gradient_pink_yellow;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 315, 135);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.fill(pink_colour);
                  sketch.drawingContext.fillStyle = gradient_pink_yellow;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 315, 135);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;
              }

              break;
            case eye_choices[5]:
              {
                // 'GREEN'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.scale(flip, 1);

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.rect(0, gridBoxSize * 0.25, gridBoxSize, gridBoxSize / 2);

                    flip = -1;
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(purple_colour);
                    sketch.rect(0, gridBoxSize * 0.25, gridBoxSize, gridBoxSize / 2);

                    flip = 1;
                  }

                  sketch.push();
                  sketch.rotate(45);
                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize * 0.7, gridBoxSize * 0.7);
                  sketch.pop();

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }
                //counter=0

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.scale(flip, 1);

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.rect(0, gridBoxSize * 0.25, gridBoxSize, gridBoxSize / 2);

                    flip = -1;
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(purple_colour);
                    sketch.rect(0, gridBoxSize * 0.25, gridBoxSize, gridBoxSize / 2);

                    flip = 1;
                  }

                  sketch.push();
                  sketch.rotate(45);
                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize * 0.7, gridBoxSize * 0.7);
                  sketch.pop();

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }
                //counter=0

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.scale(flip, 1);

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.rect(0, gridBoxSize * 0.25, gridBoxSize, gridBoxSize / 2);

                    flip = -1;
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(purple_colour);
                    sketch.rect(0, gridBoxSize * 0.25, gridBoxSize, gridBoxSize / 2);

                    flip = 1;
                  }

                  sketch.push();
                  sketch.rotate(45);
                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize * 0.7, gridBoxSize * 0.7);
                  sketch.pop();

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }
                // counter=0

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.scale(flip, 1);

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.rect(0, gridBoxSize * 0.25, gridBoxSize, gridBoxSize / 2);

                    flip = -1;
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(purple_colour);
                    sketch.rect(0, gridBoxSize * 0.25, gridBoxSize, gridBoxSize / 2);

                    flip = 1;
                  }

                  sketch.push();
                  sketch.rotate(45);
                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize * 0.7, gridBoxSize * 0.7);
                  sketch.pop();

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }
                counter = 0;
              }

              break;
            case eye_choices[6]:
              {
                // 'HETEROCHROMATIC'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.drawingContext.fillStyle = gradient_pink_yellow;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.drawingContext.fillStyle = gradient_orange_blue;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.pop();
                  sketch.pop();

                  // element end

                  sketch.pop();

                  rotate90 += 90;
                }

                rotate90 = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.drawingContext.fillStyle = gradient_pink_yellow;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.drawingContext.fillStyle = gradient_orange_blue;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.pop();
                  sketch.pop();

                  // element end

                  sketch.pop();

                  rotate90 += 90;
                }

                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.drawingContext.fillStyle = gradient_pink_yellow;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.drawingContext.fillStyle = gradient_orange_blue;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.pop();
                  sketch.pop();

                  // element end

                  sketch.pop();

                  rotate90 += 90;
                }

                rotate90 = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.drawingContext.fillStyle = gradient_pink_yellow;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.drawingContext.fillStyle = gradient_orange_blue;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.pop();
                  sketch.pop();

                  // element end

                  sketch.pop();

                  rotate90 += 90;
                }

                rotate90 = 0;
              }

              break;
          }
        }
        break;
      case 13:
        {
          // MUSIC

          switch (input_data.music) {
            case music_choices[0]:
              {
                // 'Acoustic'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  sketch.rect(-gridBoxSize / 8, 0, gridBoxSize * 0.75, gridBoxSize / 3);

                  sketch.pop();

                  counter++;
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  sketch.rect(-gridBoxSize / 8, 0, gridBoxSize * 0.75, gridBoxSize / 3);

                  sketch.pop();

                  counter++;
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  sketch.rect(-gridBoxSize / 8, 0, gridBoxSize * 0.75, gridBoxSize / 3);

                  sketch.pop();

                  counter++;
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  sketch.rect(-gridBoxSize / 8, 0, gridBoxSize * 0.75, gridBoxSize / 3);

                  sketch.pop();

                  counter++;
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case music_choices[1]:
              {
                // 'Afro'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case music_choices[2]:
              {
                // 'Blues'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(0, -gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end

                  sketch.pop();

                  rotate90 += 90;
                }

                rotate90 = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(0, -gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                }

                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(0, -gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                }

                rotate90 = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(0, -gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                }
                rotate90 = 0;
              }

              break;
            case music_choices[3]:
              {
                // 'Breakbeat'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.arc(-gridBoxSize / 2, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6, -90, -270);
                    //sketch.arc(gridBoxSize/2, gridBoxSize / 8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6,90,270)

                    sketch.pop();
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    //sketch.ellipse(-gridBoxSize / 8, gridBoxSize / 8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6)
                    sketch.arc(gridBoxSize / 8, gridBoxSize / 2, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6, 180, 0);
                    //sketch.ellipse(gridBoxSize/8, -gridBoxSize/8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6)
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.arc(-gridBoxSize / 2, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6, -90, -270);
                    //sketch.arc(gridBoxSize/2, gridBoxSize / 8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6,90,270)

                    sketch.pop();
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    //sketch.ellipse(-gridBoxSize / 8, gridBoxSize / 8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6)
                    sketch.arc(gridBoxSize / 8, gridBoxSize / 2, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6, 180, 0);
                    //sketch.ellipse(gridBoxSize/8, -gridBoxSize/8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6)
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.arc(-gridBoxSize / 2, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6, -90, -270);
                    //sketch.arc(gridBoxSize/2, gridBoxSize / 8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6,90,270)

                    sketch.pop();
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    //sketch.ellipse(-gridBoxSize / 8, gridBoxSize / 8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6)
                    sketch.arc(gridBoxSize / 8, gridBoxSize / 2, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6, 180, 0);
                    //sketch.ellipse(gridBoxSize/8, -gridBoxSize/8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6)
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.arc(-gridBoxSize / 2, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6, -90, -270);
                    //sketch.arc(gridBoxSize/2, gridBoxSize / 8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6,90,270)

                    sketch.pop();
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    //sketch.ellipse(-gridBoxSize / 8, gridBoxSize / 8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6)
                    sketch.arc(gridBoxSize / 8, gridBoxSize / 2, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6, 180, 0);
                    //sketch.ellipse(gridBoxSize/8, -gridBoxSize/8, gridBoxSize / 8 * 6, gridBoxSize / 8 * 6)
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }
                rotate90 = 0;
              }

              break;
            case music_choices[4]:
              {
                // 'Gospel'

                // TOP SIDE
                sketch.stroke(yellow_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(yellow_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 0, 180);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;
                  counter++;

                  sketch.pop();
                }
                rotate90 = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 0, 180);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;
                  counter++;

                  sketch.pop();
                }

                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 0, 180);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;
                  counter++;

                  sketch.pop();
                }

                rotate90 = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 0, 180);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;
                  counter++;
                  sketch.pop();
                }
                rotate90 = 0;
                counter = 0;
              }

              break;
            case music_choices[5]:
              {
                // 'Classical'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  }

                  if (rotate90 % 180 === 0) {
                    sketch.ellipse(0, gridBoxSize / 4 - gridBoxSize * 0.02, gridBoxSize, (gridBoxSize / 2) * 1.1);
                    sketch.ellipse(0, -gridBoxSize / 4 + gridBoxSize * 0.02, gridBoxSize, (gridBoxSize / 2) * 1.1);
                  } else {
                    sketch.ellipse(0, gridBoxSize / 4, gridBoxSize, (gridBoxSize / 2) * 1.1);
                    sketch.ellipse(0, -gridBoxSize / 4, gridBoxSize, (gridBoxSize / 2) * 1.1);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();

                  rotate90 += 90;
                  counter++;
                }

                rotate90 += 90;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 != 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  }

                  if (rotate90 % 180 === 0) {
                    sketch.ellipse(0, gridBoxSize / 4 - gridBoxSize * 0.02, gridBoxSize, (gridBoxSize / 2) * 1.1);
                    sketch.ellipse(0, -gridBoxSize / 4 + gridBoxSize * 0.02, gridBoxSize, (gridBoxSize / 2) * 1.1);
                  } else {
                    sketch.ellipse(0, gridBoxSize / 4, gridBoxSize, (gridBoxSize / 2) * 1.1);
                    sketch.ellipse(0, -gridBoxSize / 4, gridBoxSize, (gridBoxSize / 2) * 1.1);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();

                  rotate90 += 90;
                  counter++;
                }

                rotate90 += 90;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  }

                  if (rotate90 % 180 === 0) {
                    sketch.ellipse(0, gridBoxSize / 4 - gridBoxSize * 0.02, gridBoxSize, (gridBoxSize / 2) * 1.1);
                    sketch.ellipse(0, -gridBoxSize / 4 + gridBoxSize * 0.02, gridBoxSize, (gridBoxSize / 2) * 1.1);
                  } else {
                    sketch.ellipse(0, gridBoxSize / 4, gridBoxSize, (gridBoxSize / 2) * 1.1);
                    sketch.ellipse(0, -gridBoxSize / 4, gridBoxSize, (gridBoxSize / 2) * 1.1);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();

                  rotate90 += 90;
                  counter++;
                }

                rotate90 += 90;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 != 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  }

                  if (rotate90 % 180 === 0) {
                    sketch.ellipse(0, gridBoxSize / 4 - gridBoxSize * 0.02, gridBoxSize, (gridBoxSize / 2) * 1.1);
                    sketch.ellipse(0, -gridBoxSize / 4 + gridBoxSize * 0.02, gridBoxSize, (gridBoxSize / 2) * 1.1);
                  } else {
                    sketch.ellipse(0, gridBoxSize / 4, gridBoxSize, (gridBoxSize / 2) * 1.1);
                    sketch.ellipse(0, -gridBoxSize / 4, gridBoxSize, (gridBoxSize / 2) * 1.1);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();

                  rotate90 += 90;
                  counter++;
                }
                rotate90 = 0;
              }

              break;
            case music_choices[6]:
              {
                // 'Country'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.ellipse(-gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.ellipse(-gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.ellipse(-gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.fill(pink_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.ellipse(-gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize / 2, gridBoxSize / 2);

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
              }

              break;
            case music_choices[7]:
              {
                // 'Dance / Electronic'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rotate(45);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                    sketch.rotate(-45);
                  }

                  //sketch.rotate(-45)
                  sketch.ellipse(0, 0, gridBoxSize / 2, gridBoxSize * 1.3);

                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rotate(45);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                    sketch.rotate(-45);
                  }

                  //sketch.rotate(-45)
                  sketch.ellipse(0, 0, gridBoxSize / 2, gridBoxSize * 1.3);

                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rotate(45);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                    sketch.rotate(-45);
                  }

                  //sketch.rotate(-45)
                  sketch.ellipse(0, 0, gridBoxSize / 2, gridBoxSize * 1.3);

                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rotate(45);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                    sketch.rotate(-45);
                  }

                  //sketch.rotate(-45)
                  sketch.ellipse(0, 0, gridBoxSize / 2, gridBoxSize * 1.3);

                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case music_choices[8]:
              {
                // 'Disco'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  //sketch.rotate(90)

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.beginShape();
                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  counter++;
                  //rotate90+=90

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  //sketch.rotate(90)

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.beginShape();
                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  counter++;
                  //rotate90+=90

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  //sketch.rotate(90)

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.beginShape();
                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  counter++;
                  //rotate90+=90

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  //sketch.rotate(90)

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.beginShape();
                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  counter++;
                  //rotate90+=90

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case music_choices[9]:
              {
                // 'Drum & Bass'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.rotate(90);

                  if (counter % 2 === 0) {
                    //sketch.scale(-1,1)
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  }

                  sketch.beginShape();
                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  counter++;
                  //rotate90+=90

                  sketch.pop();
                  // element end

                  sketch.pop();

                  rotate90 += 90;
                }

                rotate90 = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.rotate(90);

                  if (counter % 2 === 0) {
                    //sketch.scale(-1,1)
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  }

                  sketch.beginShape();
                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  counter++;
                  //rotate90+=90

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                }

                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.rotate(90);

                  if (counter % 2 === 0) {
                    //sketch.scale(-1,1)
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  }

                  sketch.beginShape();
                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  counter++;
                  //rotate90+=90

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                }

                rotate90 = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.rotate(90);

                  if (counter % 2 === 0) {
                    //sketch.scale(-1,1)
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  }

                  sketch.beginShape();
                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  counter++;
                  //rotate90+=90

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                }
                rotate90 = 0;
              }

              break;
            case music_choices[10]:
              {
                // 'Folk'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(blue_colour);
                  sketch.rect(-gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.fill(blue_colour);
                  sketch.rect(-gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.fill(blue_colour);
                  sketch.rect(-gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.fill(blue_colour);
                  sketch.rect(-gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }
                rotate90 = 0;
              }

              break;
            case music_choices[11]:
              {
                // 'Funk'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(purple_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(orange_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(blue_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(orange_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(blue_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }
              }
              break;
            case music_choices[12]:
              {
                // 'Hiphop'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(purple_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  }

                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  }

                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  }

                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  }

                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }
              }
              break;
            case music_choices[13]:
              {
                // 'Indie'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                sketch.fill(blue_colour);

                let gradient_yellow_turq_2 = sketch.drawingContext.createLinearGradient(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);

                gradient_yellow_turq_2.addColorStop(0, sketch.color(pink_colour));
                gradient_yellow_turq_2.addColorStop(1, sketch.color(turq_colour));

                sketch.drawingContext.fillStyle = gradient_yellow_turq_2;
                sketch.rect(placeXYminus + (placeXYplus - gridBoxSize - placeXYminus) / 2, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize - placeXYminus, gridBoxSize);

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(purple_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(yellow_colour);
                  sketch.rect(0, -gridBoxSize / 2 + (0.5 * gridBoxSize) / 6, gridBoxSize, (gridBoxSize * 0.5) / 3);
                  sketch.rect(0, gridBoxSize / 2 - (0.5 * gridBoxSize) / 6, gridBoxSize, (gridBoxSize * 0.5) / 3);
                  sketch.rect(0, 0, gridBoxSize, (gridBoxSize * 0.5) / 3);

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(turq_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                let gradient_yellow_turq_3 = sketch.drawingContext.createLinearGradient(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);

                gradient_yellow_turq_3.addColorStop(0, sketch.color(turq_colour));
                gradient_yellow_turq_3.addColorStop(1, sketch.color(pink_colour));

                sketch.drawingContext.fillStyle = gradient_yellow_turq_3;
                sketch.rect(placeXYplus - 0.5 * gridBoxSize, placeXYminus + (placeXYplus - gridBoxSize - placeXYminus) / 2, gridBoxSize, placeXYplus - gridBoxSize - placeXYminus);

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.fill(yellow_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(yellow_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                let gradient_yellow_turq_4 = sketch.drawingContext.createLinearGradient(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);

                gradient_yellow_turq_4.addColorStop(0, sketch.color(pink_colour));
                gradient_yellow_turq_4.addColorStop(1, sketch.color(turq_colour));

                sketch.drawingContext.fillStyle = gradient_yellow_turq_4;
                sketch.rect(placeXYplus + (placeXYminus + gridBoxSize - placeXYplus) / 2, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize - placeXYminus, gridBoxSize);

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.fill(yellow_colour);
                  sketch.rect(0, -gridBoxSize / 2 + (0.5 * gridBoxSize) / 6, gridBoxSize, (gridBoxSize * 0.5) / 3);
                  sketch.rect(0, gridBoxSize / 2 - (0.5 * gridBoxSize) / 6, gridBoxSize, (gridBoxSize * 0.5) / 3);
                  sketch.rect(0, 0, gridBoxSize, (gridBoxSize * 0.5) / 3);

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(yellow_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                let gradient_yellow_turq_5 = sketch.drawingContext.createLinearGradient(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);

                gradient_yellow_turq_5.addColorStop(0, sketch.color(turq_colour));
                gradient_yellow_turq_5.addColorStop(1, sketch.color(pink_colour));

                sketch.drawingContext.fillStyle = gradient_yellow_turq_5;
                sketch.rect(placeXYminus + 0.5 * gridBoxSize, placeXYplus + (placeXYminus + gridBoxSize - placeXYplus) / 2, gridBoxSize, placeXYplus - gridBoxSize - placeXYminus);

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.fill(yellow_colour);
                  sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 4);
                  sketch.pop();
                  // element end

                  sketch.pop();
                }
              }
              break;
            case music_choices[14]:
              {
                // 'Jazz'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_white;

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(pink_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_white;

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(pink_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_white;

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(pink_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_white;

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(pink_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case music_choices[15]:
              {
                // 'K-pop'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  }

                  switch (sequenceCounter) {
                    case 0:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 1:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 2:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 3:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 4:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 5:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                  }

                  counter++;

                  if (sequenceCounter === 5) {
                    sequenceCounter = 0;
                  } else {
                    sequenceCounter++;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                sequenceCounter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  }

                  switch (sequenceCounter) {
                    case 0:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 1:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 2:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 3:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 4:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 5:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                  }

                  counter++;

                  if (sequenceCounter === 5) {
                    sequenceCounter = 0;
                  } else {
                    sequenceCounter++;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                sequenceCounter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  }

                  switch (sequenceCounter) {
                    case 0:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 1:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 2:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 3:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 4:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 5:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                  }

                  counter++;

                  if (sequenceCounter === 5) {
                    sequenceCounter = 0;
                  } else {
                    sequenceCounter++;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                sequenceCounter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  } else {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  }

                  switch (sequenceCounter) {
                    case 0:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 1:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 2:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 3:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 4:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 5:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                  }

                  counter++;

                  if (sequenceCounter === 5) {
                    sequenceCounter = 0;
                  } else {
                    sequenceCounter++;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
                sequenceCounter = 0;
              }
              break;
            case music_choices[16]:
              {
                // 'Latin'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(purple_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);

                  if (counter % 2 === 0) {
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  } else {
                    sketch.rotate(-90);
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin
                  sketch.push();

                  sketch.fill(purple_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);

                  if (counter % 2 === 0) {
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  } else {
                    sketch.rotate(-90);
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin
                  sketch.push();

                  sketch.fill(purple_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);

                  if (counter % 2 === 0) {
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  } else {
                    sketch.rotate(-90);
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin
                  sketch.push();

                  sketch.fill(purple_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);

                  if (counter % 2 === 0) {
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  } else {
                    sketch.rotate(-90);
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case music_choices[17]:
              {
                // 'Metal'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(orange_colour);
                  sketch.rotate(15);
                  sketch.rect(0, 0, gridBoxSize * 0.81, gridBoxSize * 0.81);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(orange_colour);
                  sketch.rotate(15);
                  sketch.rect(0, 0, gridBoxSize * 0.81, gridBoxSize * 0.81);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(orange_colour);
                  sketch.rotate(15);
                  sketch.rect(0, 0, gridBoxSize * 0.81, gridBoxSize * 0.81);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(orange_colour);
                  sketch.rotate(15);
                  sketch.rect(0, 0, gridBoxSize * 0.81, gridBoxSize * 0.81);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case music_choices[18]:
              {
                // 'Pop'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 315, 135);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 315, 135);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }

                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 315, 135);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }

                rotate90 = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 315, 135);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;
              }

              break;
            case music_choices[19]:
              {
                // 'Punk'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.scale(flip, flip);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.rect(-gridBoxSize / 2 + gridBoxSize / 6, 0, gridBoxSize / 3, gridBoxSize);

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.scale(flip, flip);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.rect(-gridBoxSize / 2 + gridBoxSize / 6, 0, gridBoxSize / 3, gridBoxSize);

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.scale(flip, flip);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.rect(-gridBoxSize / 2 + gridBoxSize / 6, 0, gridBoxSize / 3, gridBoxSize);

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.scale(flip, flip);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.rect(-gridBoxSize / 2 + gridBoxSize / 6, 0, gridBoxSize / 3, gridBoxSize);

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case music_choices[20]:
              {
                // 'Reggae'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.push();
                    sketch.scale(-1, 1);
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                    sketch.pop();
                  }
                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.push();
                    sketch.scale(-1, 1);
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                    sketch.pop();
                  }
                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.push();
                    sketch.scale(-1, 1);
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                    sketch.pop();
                  }
                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.push();
                    sketch.scale(-1, 1);
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                    sketch.pop();
                  }
                  sketch.pop();
                  counter++;
                  // element end

                  sketch.pop();
                }
              }

              break;
            case music_choices[21]:
              {
                // 'RnB'
                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 270, 90);
                  }
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 270, 90);
                  }
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 270, 90);
                  }
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 270, 90);
                  }
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case music_choices[22]:
              {
                // 'Rock'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.push();

                    sketch.rotate(90);
                    sketch.fill(brown_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                    sketch.pop();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.push();

                    sketch.rotate(90);
                    sketch.fill(brown_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                    sketch.pop();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.push();

                    sketch.rotate(90);
                    sketch.fill(brown_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                    sketch.pop();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.push();

                    sketch.rotate(90);
                    sketch.fill(brown_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                    sketch.pop();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case music_choices[23]:
              {
                // 'Salsa'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.drawingContext.fillStyle = gradient_pink_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.drawingContext.fillStyle = gradient_pink_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.drawingContext.fillStyle = gradient_pink_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  } else {
                    sketch.fill(brown_colour);
                    sketch.drawingContext.fillStyle = gradient_pink_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case music_choices[24]:
              {
                // 'Soul'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);

                    sketch.pop();
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);

                    sketch.pop();
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);

                    sketch.pop();
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);

                    sketch.pop();
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }
                rotate90 = 0;
              }

              break;
            case music_choices[25]:
              {
                // 'Techno'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }

                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }

                rotate90 = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);

                  sketch.pop();
                  // element end

                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;
              }

              break;
            case music_choices[26]:
              {
                // 'Traditional'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.rect(-gridBoxSize * 0.125, -gridBoxSize / 2 + gridBoxSize / 6, gridBoxSize * 0.75, gridBoxSize / 3);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.rect(-gridBoxSize * 0.125, gridBoxSize / 2 - gridBoxSize / 6, gridBoxSize * 0.75, gridBoxSize / 3);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.rect(-gridBoxSize * 0.125, -gridBoxSize / 2 + gridBoxSize / 6, gridBoxSize * 0.75, gridBoxSize / 3);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.rect(-gridBoxSize * 0.125, gridBoxSize / 2 - gridBoxSize / 6, gridBoxSize * 0.75, gridBoxSize / 3);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.rect(-gridBoxSize * 0.125, -gridBoxSize / 2 + gridBoxSize / 6, gridBoxSize * 0.75, gridBoxSize / 3);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.rect(-gridBoxSize * 0.125, gridBoxSize / 2 - gridBoxSize / 6, gridBoxSize * 0.75, gridBoxSize / 3);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.rect(-gridBoxSize * 0.125, -gridBoxSize / 2 + gridBoxSize / 6, gridBoxSize * 0.75, gridBoxSize / 3);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.rect(-gridBoxSize * 0.125, gridBoxSize / 2 - gridBoxSize / 6, gridBoxSize * 0.75, gridBoxSize / 3);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }
                counter = 0;
              }

              break;
            case music_choices[27]:
              {
                // 'Other'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);
                  sketch.arc(-gridBoxSize / 2, -gridBoxSize / 2, gridBoxSize * 2, gridBoxSize * 2, 0, 90);

                  sketch.pop();
                  rotate90 += 90;

                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);
                  sketch.arc(-gridBoxSize / 2, -gridBoxSize / 2, gridBoxSize * 2, gridBoxSize * 2, 0, 90);

                  sketch.pop();
                  rotate90 += 90;

                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);
                  sketch.arc(-gridBoxSize / 2, -gridBoxSize / 2, gridBoxSize * 2, gridBoxSize * 2, 0, 90);

                  sketch.pop();
                  rotate90 += 90;

                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);
                  sketch.arc(-gridBoxSize / 2, -gridBoxSize / 2, gridBoxSize * 2, gridBoxSize * 2, 0, 90);

                  sketch.pop();
                  rotate90 += 90;

                  // element end

                  sketch.pop();
                }
                rotate90 = 0;
              }

              break;
          }
        }
        break;
      case 12:
        {
          // LIVING

          let output_10 = sketch.transToBinary(input_data.living, sketch.round(aantalVakjes));
          let splitReference = sketch.calcResponsiv(Math.floor(output_10.length / 4), aantalVakjes);

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // TOP SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
            sketch.rotate(0);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element017_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element017_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // RIGHT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
            sketch.rotate(90);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element017_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element017_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end
            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 1200, 200)
          //text(splitCounter_2x2,400,400)
          //text(charCounter, 1400, 400)
          //text(output_gender.length, 1600, 600)

          //splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // BOTTOM SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
            sketch.rotate(180);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element017_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element017_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 200, 200)
          //text(splitCounter_2x2,600,200)
          //text(charCounter, 400, 400)
          //text(output_gender.length, 600, 600)

          // splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // LEFT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
            sketch.rotate(270);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element017_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element017_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element017_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element017_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          charCounter = 0;
          splitCounter = 0;

          splitCounter_4x4 = 0;
          splitCounter_3x3 = 0;
          splitCounter_2x2 = 0;
          splitCounter_1x1 = 0;
        }
        break;
      case 11:
        {
          // TIME

          switch (input_data.time) {
            case time_choices[0]:
              {
                // 'BEING SOCIAL'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:

                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.rotate(90);
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);

                    counter++;

                    sketch.pop();
                  } else {
                    sketch.push();

                    sketch.rotate(0);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);

                    counter++;

                    sketch.pop();
                  }

                  // element end

                  sketch.pop();
                }

                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:

                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.rotate(90);
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);

                    counter++;

                    sketch.pop();
                  } else {
                    sketch.push();

                    sketch.rotate(0);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);

                    counter++;

                    sketch.pop();
                  }

                  // element end

                  sketch.pop();
                }

                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:

                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.rotate(90);
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);

                    counter++;

                    sketch.pop();
                  } else {
                    sketch.push();

                    sketch.rotate(0);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);

                    counter++;

                    sketch.pop();
                  }

                  // element end

                  sketch.pop();
                }

                counter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:

                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.rotate(90);
                    sketch.fill(brown_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);

                    counter++;

                    sketch.pop();
                  } else {
                    sketch.push();

                    sketch.rotate(0);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(brown_colour);
                    sketch.rect(0, -gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);
                    sketch.rect(0, gridBoxSize / 5, gridBoxSize, gridBoxSize / 8);

                    counter++;

                    sketch.pop();
                  }

                  // element end

                  sketch.pop();
                }

                counter = 0;
              }

              break;
            case time_choices[1]:
              {
                // 'CREATIVE HOBBY'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);

                    sketch.beginShape();

                    sketch.vertex(0, 0);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case time_choices[2]:
              {
                // 'CULTURAL ACTIVITIES'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);

                    sketch.pop();
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);

                    sketch.pop();
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);

                    sketch.pop();
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);
                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);

                    sketch.pop();
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize);

                    sketch.fill(turq_colour);
                    sketch.ellipse(-gridBoxSize / 8, -gridBoxSize / 8, (gridBoxSize / 8) * 6, (gridBoxSize / 8) * 6);
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                  counter++;
                }
                rotate90 = 0;
              }

              break;
            case time_choices[3]:
              {
                // 'GAMING'

                // TOP SIDE
                sketch.stroke(turq_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(turq_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.rect(-gridBoxSize / 8, 0, gridBoxSize * 0.75, gridBoxSize / 4);

                    sketch.fill(turq_colour);
                    sketch.rect((gridBoxSize / 8) * 3, 0, gridBoxSize / 4, gridBoxSize / 4);
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.rect(-gridBoxSize / 8, 0, gridBoxSize * 0.75, gridBoxSize / 4);

                    sketch.fill(turq_colour);
                    sketch.rect((gridBoxSize / 8) * 3, 0, gridBoxSize / 4, gridBoxSize / 4);
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.rect(-gridBoxSize / 8, 0, gridBoxSize * 0.75, gridBoxSize / 4);

                    sketch.fill(turq_colour);
                    sketch.rect((gridBoxSize / 8) * 3, 0, gridBoxSize / 4, gridBoxSize / 4);
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.rect(-gridBoxSize / 8, 0, gridBoxSize * 0.75, gridBoxSize / 4);

                    sketch.fill(turq_colour);
                    sketch.rect((gridBoxSize / 8) * 3, 0, gridBoxSize / 4, gridBoxSize / 4);
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                  counter++;
                }
              }

              break;
            case time_choices[4]:
              {
                // 'READING'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(yellow_colour);
                  //sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  if (counter === 2) {
                    sketch.drawingContext.fillStyle = gradient_orange_blue;

                    sketch.rect(-0.5 * gridBoxSize, 0, 2 * gridBoxSize, gridBoxSize / 4);
                    counter = 0;
                  } else {
                    counter++;
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.fill(yellow_colour);
                  //sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  if (counter === 2) {
                    sketch.drawingContext.fillStyle = gradient_orange_blue;

                    sketch.rect(-0.5 * gridBoxSize, 0, 2 * gridBoxSize, gridBoxSize / 4);
                    counter = 0;
                  } else {
                    counter++;
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.fill(yellow_colour);
                  //sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  if (counter === 2) {
                    sketch.drawingContext.fillStyle = gradient_orange_blue;

                    sketch.rect(-0.5 * gridBoxSize, 0, 2 * gridBoxSize, gridBoxSize / 4);
                    counter = 0;
                  } else {
                    counter++;
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.fill(yellow_colour);
                  //sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  if (counter === 2) {
                    sketch.drawingContext.fillStyle = gradient_orange_blue;

                    sketch.rect(-0.5 * gridBoxSize, 0, 2 * gridBoxSize, gridBoxSize / 4);
                    counter = 0;
                  } else {
                    counter++;
                  }
                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case time_choices[5]:
              {
                // 'SLEEPING'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.drawingContext.fillStyle = gradient_orange_blue;
                  if (drawDot === placeXYminus + 0.5 * gridBoxSize) {
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  } else if (counter % 2 !== 0) {
                    sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                  }
                  sketch.fill(pink_colour);
                  sketch.ellipse(0, 0, gridBoxSize / 3, gridBoxSize / 3);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.drawingContext.fillStyle = gradient_orange_blue;
                  if (drawDot === placeXYminus + 0.5 * gridBoxSize) {
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  } else if (counter % 2 !== 0) {
                    sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                  }
                  sketch.fill(pink_colour);
                  sketch.ellipse(0, 0, gridBoxSize / 3, gridBoxSize / 3);

                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.drawingContext.fillStyle = gradient_orange_blue;
                  if (drawDot === placeXYplus - 0.5 * gridBoxSize) {
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  } else if (counter % 2 !== 0) {
                    sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                  }
                  sketch.fill(pink_colour);
                  sketch.ellipse(0, 0, gridBoxSize / 3, gridBoxSize / 3);

                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.drawingContext.fillStyle = gradient_orange_blue;
                  if (drawDot === placeXYplus - 0.5 * gridBoxSize) {
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  } else if (counter % 2 !== 0) {
                    sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                  }
                  sketch.fill(pink_colour);
                  sketch.ellipse(0, 0, gridBoxSize / 3, gridBoxSize / 3);

                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case time_choices[6]:
              {
                // 'SPORTS / EXERCISE'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);
                  sketch.arc(-gridBoxSize / 2, -gridBoxSize / 2, gridBoxSize * 2, gridBoxSize * 2, 0, 90);

                  sketch.pop();
                  rotate90 += 90;

                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);
                  sketch.arc(-gridBoxSize / 2, -gridBoxSize / 2, gridBoxSize * 2, gridBoxSize * 2, 0, 90);

                  sketch.pop();
                  rotate90 += 90;

                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);
                  sketch.arc(-gridBoxSize / 2, -gridBoxSize / 2, gridBoxSize * 2, gridBoxSize * 2, 0, 90);

                  sketch.pop();
                  rotate90 += 90;

                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);
                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(turq_colour);
                  sketch.arc(-gridBoxSize / 2, -gridBoxSize / 2, gridBoxSize * 2, gridBoxSize * 2, 0, 90);

                  sketch.pop();
                  rotate90 += 90;

                  // element end

                  sketch.pop();
                }
                rotate90 = 0;
              }

              break;
            case time_choices[7]:
              {
                // 'WATCHING SERIES'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
            case time_choices[8]:
              {
                // 'I JUST WORK'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(orange_colour);
                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(blue_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize / 2, 0, 180);

                  sketch.pop();
                  // element end

                  sketch.pop();

                  rotate90 += 90;
                }
                rotate90 = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(orange_colour);
                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(blue_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize / 2, 0, 180);

                  sketch.pop();
                  // element end

                  sketch.pop();

                  rotate90 += 90;
                }
                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(orange_colour);
                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(blue_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize / 2, 0, 180);

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                }
                rotate90 = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.rotate(rotate90);

                  sketch.fill(blue_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(orange_colour);
                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(yellow_colour);
                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize / 2);

                  sketch.fill(blue_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize / 2, 0, 180);

                  sketch.pop();
                  // element end

                  sketch.pop();
                  rotate90 += 90;
                }

                rotate90 = 0;
              }
              break;
            case time_choices[9]:
              {
                // 'OTHER'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  }

                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  }

                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  }

                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  }

                  sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }
                counter = 0;
              }

              break;
          }
        }
        break;
      case 10:
        {
          // COMPLIMENT

          let output_compliment = sketch.transToBinary(input_data.compliment, sketch.round(aantalVakjes));
          let splitReference = sketch.calcResponsiv(Math.floor(output_compliment.length / 4), aantalVakjes);

          //text(output_compliment,sketch.width-3100,200)
          //text(input_data.compliment,1000,200)

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // TOP SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
            sketch.rotate(0);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_compliment.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element008_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element008_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // RIGHT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
            sketch.rotate(90);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_compliment.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element008_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element008_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end
            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 1200, 200)
          //text(splitCounter_2x2,400,400)
          //text(charCounter, 1400, 400)
          //text(output_gender.length, 1600, 600)

          //splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // BOTTOM SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
            sketch.rotate(180);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_compliment.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element008_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element008_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 200, 200)
          //text(splitCounter_2x2,600,200)
          //text(charCounter, 400, 400)
          //text(output_gender.length, 600, 600)

          // splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // LEFT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
            sketch.rotate(270);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_compliment.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element008_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element008_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_compliment.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element008_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element008_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          charCounter = 0;
          splitCounter = 0;

          splitCounter_4x4 = 0;
          splitCounter_3x3 = 0;
          splitCounter_2x2 = 0;
          splitCounter_1x1 = 0;
        }
        break;
      case 9:
        {
          // INTRO EXTRO

          switch (input_data.intro_extro) {
            case intro_extro_choices[0]:
              {
                // 'INTROVERT'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                  }
                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.rotate(180);
                  sketch.drawingContext.fillStyle = gradient_yellow_pink;

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 4, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                  }
                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.rotate(180);
                  sketch.drawingContext.fillStyle = gradient_yellow_pink;

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 4, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                  }
                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.rotate(180);
                  sketch.drawingContext.fillStyle = gradient_yellow_pink;

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 4, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                  }
                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.rotate(180);
                  sketch.drawingContext.fillStyle = gradient_yellow_pink;

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 4, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
              }
              break;
            case intro_extro_choices[1]:
              {
                // 'LIGHTLY INTROVERT'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.scale(flip, flip);

                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();

                  if (counter % 3 === 0 || counter % 3 === 1) {
                    sketch.scale(flip_2, flip_2);

                    sketch.fill(orange_colour);

                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, 0);
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);

                    sketch.beginShape();
                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  } else {
                    sketch.fill(orange_colour);

                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, 0);
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, 0);
                    sketch.vertex(0, gridBoxSize / 2);

                    sketch.endShape(sketch.CLOSE);
                    flip_2 *= -1;
                  }

                  sketch.pop();
                  // element end
                  flip *= -1;
                  flip_2 *= -1;
                  counter++;
                  sketch.pop();
                }
                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.scale(flip, flip);

                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();

                  if (counter % 3 === 0 || counter % 3 === 1) {
                    sketch.scale(flip_2, flip_2);

                    sketch.fill(orange_colour);

                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, 0);
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);

                    sketch.beginShape();
                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  } else {
                    sketch.fill(orange_colour);

                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, 0);
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, 0);
                    sketch.vertex(0, gridBoxSize / 2);

                    sketch.endShape(sketch.CLOSE);
                    flip_2 *= -1;
                  }

                  sketch.pop();
                  // element end
                  flip *= -1;
                  flip_2 *= -1;
                  counter++;
                  sketch.pop();
                }
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.scale(flip, flip);

                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();

                  if (counter % 3 === 0 || counter % 3 === 1) {
                    sketch.scale(flip_2, flip_2);

                    sketch.fill(orange_colour);

                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, 0);
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);

                    sketch.beginShape();
                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  } else {
                    sketch.fill(orange_colour);

                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, 0);
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, 0);
                    sketch.vertex(0, gridBoxSize / 2);

                    sketch.endShape(sketch.CLOSE);
                    flip_2 *= -1;
                  }

                  sketch.pop();
                  // element end
                  flip *= -1;
                  flip_2 *= -1;
                  counter++;
                  sketch.pop();
                }
                counter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.scale(flip, flip);

                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();

                  if (counter % 3 === 0 || counter % 3 === 1) {
                    sketch.scale(flip_2, flip_2);

                    sketch.fill(orange_colour);

                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, 0);
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);

                    sketch.beginShape();
                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                    sketch.endShape(sketch.CLOSE);
                  } else {
                    sketch.fill(orange_colour);

                    sketch.beginShape();
                    sketch.vertex(-gridBoxSize / 2, 0);
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, 0);
                    sketch.vertex(0, gridBoxSize / 2);

                    sketch.endShape(sketch.CLOSE);
                    flip_2 *= -1;
                  }

                  sketch.pop();
                  // element end
                  flip *= -1;
                  flip_2 *= -1;
                  counter++;
                  sketch.pop();
                }

                flip = 0;
                flip_2 = 0;
                counter = 0;
              }

              break;
            case intro_extro_choices[2]:
              {
                // 'AMBIVERT'

                // TOP SIDE
                sketch.stroke(turq_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(turq_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(pink_colour);
                  sketch.rotate(45);
                  sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  sketch.pop();
                  // element end
                  rotate90 -= 90;
                  sketch.pop();
                }

                rotate90 = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(pink_colour);
                  sketch.rotate(45);
                  sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  sketch.pop();
                  // element end
                  rotate90 -= 90;
                  sketch.pop();
                }

                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(pink_colour);
                  sketch.rotate(45);
                  sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  sketch.pop();
                  // element end
                  rotate90 -= 90;
                  sketch.pop();
                }

                rotate90 = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(pink_colour);
                  sketch.rotate(45);
                  sketch.rect(0, 0, gridBoxSize / 2, gridBoxSize / 2);
                  sketch.pop();
                  // element end
                  rotate90 -= 90;
                  sketch.pop();
                }

                rotate90 = 0;
              }
              break;
            case intro_extro_choices[3]:
              {
                // 'LIGHTLY EXTROVERT'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 5, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 5);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end
                  rotate90 -= 90;

                  sketch.pop();
                }

                rotate90 = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 5, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 5);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end
                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 5, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 5);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end
                  rotate90 -= 90;

                  sketch.pop();
                }

                rotate90 = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.rotate(rotate90);

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 5, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 5);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end
                  rotate90 -= 90;

                  sketch.pop();
                }
                rotate90 = 0;
              }
              break;
            case intro_extro_choices[4]:
              {
                // 'EXTROVERT'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(turq_colour);
                  sketch.rect(-gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.fill(orange_colour);
                  sketch.rect(gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.rect();

                  sketch.pop();

                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.fill(turq_colour);
                  sketch.rect(-gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.fill(orange_colour);
                  sketch.rect(gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.rect();

                  sketch.pop();

                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.fill(turq_colour);
                  sketch.rect(-gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.fill(orange_colour);
                  sketch.rect(gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.rect();

                  sketch.pop();

                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.fill(turq_colour);
                  sketch.rect(-gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.fill(orange_colour);
                  sketch.rect(gridBoxSize / 4, 0, gridBoxSize / 2, gridBoxSize);

                  sketch.rect();

                  sketch.pop();

                  // element end

                  sketch.pop();
                }
              }
              break;
          }
        }
        break;
      case 8:
        {
          // RECKLESS CAUTIOUS

          switch (input_data.reck_caut) {
            case reck_caut_choices[0]:
              {
                // 'HIGHLY RECKLESS'
                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (sequenceCounter === 2) {
                    sketch.scale(-1, 1);
                  } else if (sequenceCounter === 3) {
                    sequenceCounter = 0;
                  }

                  sketch.fill(blue_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, 0);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  if (sequenceCounter !== 2) {
                    sketch.fill(turq_colour);
                    sketch.beginShape();

                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  sketch.pop();
                  // element end

                  sequenceCounter++;
                  sketch.pop();
                }
                sequenceCounter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (sequenceCounter === 2) {
                    sketch.scale(-1, 1);
                  } else if (sequenceCounter === 3) {
                    sequenceCounter = 0;
                  }

                  sketch.fill(blue_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, 0);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  if (sequenceCounter !== 2) {
                    sketch.fill(turq_colour);
                    sketch.beginShape();

                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  sketch.pop();
                  // element end

                  sequenceCounter++;

                  sketch.pop();
                }
                sequenceCounter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (sequenceCounter === 2) {
                    sketch.scale(-1, 1);
                  } else if (sequenceCounter === 3) {
                    sequenceCounter = 0;
                  }

                  sketch.fill(blue_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, 0);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  if (sequenceCounter !== 2) {
                    sketch.fill(turq_colour);
                    sketch.beginShape();

                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  sketch.pop();
                  // element end

                  sequenceCounter++;

                  sketch.pop();
                }

                sequenceCounter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.drawingContext.fillStyle = gradient_yellow_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (sequenceCounter === 2) {
                    sketch.scale(-1, 1);
                  } else if (sequenceCounter === 3) {
                    sequenceCounter = 0;
                  }

                  sketch.fill(blue_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, 0);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  if (sequenceCounter !== 2) {
                    sketch.fill(turq_colour);
                    sketch.beginShape();

                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, 0);
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  sketch.pop();
                  // element end

                  sequenceCounter++;

                  sketch.pop();
                }
                sequenceCounter = 0;
              }
              break;
            case reck_caut_choices[1]:
              {
                // 'QUITE RECKLESS'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  let a;
                  let b;

                  if (counter % 2 === 0) {
                    sketch.scale(1, -1);
                 a = pink_colour;
                b = blue_colour;
                  } else {
                a = blue_colour;
               b = pink_colour;
                  }
                  sketch.fill(a);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(b);
                  sketch.rect(-gridBoxSize / 8, gridBoxSize / 2 - gridBoxSize / 8, gridBoxSize * 0.75, gridBoxSize / 4);
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  let a;
                  let b;

                  if (counter % 2 === 0) {
                    sketch.scale(1, -1);
                    a = pink_colour;
                    b = blue_colour;
                  } else {
                    a = blue_colour;
                    b = pink_colour;
                  }
                  sketch.fill(a);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(b);
                  sketch.rect(-gridBoxSize / 8, gridBoxSize / 2 - gridBoxSize / 8, gridBoxSize * 0.75, gridBoxSize / 4);
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  let a;
                  let b;

                  if (counter % 2 === 0) {
                    sketch.scale(1, -1);
                    a = pink_colour;
                    b = blue_colour;
                  } else {
                    a = blue_colour;
                    b = pink_colour;
                  }
                  sketch.fill(a);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(b);
                  sketch.rect(-gridBoxSize / 8, gridBoxSize / 2 - gridBoxSize / 8, gridBoxSize * 0.75, gridBoxSize / 4);
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  let a;
                  let b;

                  if (counter % 2 === 0) {
                    sketch.scale(1, -1);
                    a = pink_colour;
                    b = blue_colour;
                  } else {
                    a = blue_colour;
                    b = pink_colour;
                  }
                  sketch.fill(a);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(b);
                  sketch.rect(-gridBoxSize / 8, gridBoxSize / 2 - gridBoxSize / 8, gridBoxSize * 0.75, gridBoxSize / 4);
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case reck_caut_choices[2]:
              {
                // 'BIT OF BOTH'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.fill(orange_colour);
                    sketch.rect(-gridBoxSize / 4, -gridBoxSize / 12, gridBoxSize / 2, (gridBoxSize / 6) * 5);
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.fill(blue_colour);
                    sketch.rect(-gridBoxSize / 4, gridBoxSize / 12, gridBoxSize / 2, (gridBoxSize / 6) * 5);
                  }

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.fill(orange_colour);
                    sketch.rect(-gridBoxSize / 4, -gridBoxSize / 12, gridBoxSize / 2, (gridBoxSize / 6) * 5);
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.fill(blue_colour);
                    sketch.rect(-gridBoxSize / 4, gridBoxSize / 12, gridBoxSize / 2, (gridBoxSize / 6) * 5);
                  }

                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.fill(orange_colour);
                    sketch.rect(-gridBoxSize / 4, -gridBoxSize / 12, gridBoxSize / 2, (gridBoxSize / 6) * 5);
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.fill(blue_colour);
                    sketch.rect(-gridBoxSize / 4, gridBoxSize / 12, gridBoxSize / 2, (gridBoxSize / 6) * 5);
                  }

                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.fill(orange_colour);
                    sketch.rect(-gridBoxSize / 4, -gridBoxSize / 12, gridBoxSize / 2, (gridBoxSize / 6) * 5);
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(orange_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                    sketch.vertex(0, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                    sketch.endShape();

                    sketch.fill(blue_colour);
                    sketch.rect(-gridBoxSize / 4, gridBoxSize / 12, gridBoxSize / 2, (gridBoxSize / 6) * 5);
                  }

                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case reck_caut_choices[3]:
              {
                // 'QUITE CAUTIOUS'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.scale(flip, flip);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.rect(-gridBoxSize / 2 + gridBoxSize / 6, 0, gridBoxSize / 3, gridBoxSize);

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.scale(flip, flip);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.rect(-gridBoxSize / 2 + gridBoxSize / 6, 0, gridBoxSize / 3, gridBoxSize);

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.scale(flip, flip);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.rect(-gridBoxSize / 2 + gridBoxSize / 6, 0, gridBoxSize / 3, gridBoxSize);

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.scale(flip, flip);

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(turq_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize / 3);
                  sketch.rect(-gridBoxSize / 2 + gridBoxSize / 6, 0, gridBoxSize / 3, gridBoxSize);

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case reck_caut_choices[4]:
              {
                // 'EXTREMELY CAUTIOUS'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(brown_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(brown_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(brown_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(brown_colour);
                  }

                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.pop();
                  // element end

                  sketch.pop();

                  counter++;
                }
              }
              break;
          }
        }
        break;
      case 7:
        {
          // SUPERPOWER

          let output_superpower = sketch.transToBinaryShort_X2(input_data.superpower, sketch.round(aantalVakjes));
          let splitReference = sketch.calcResponsiv(Math.floor(output_superpower.length / 4), aantalVakjes);

          //text(output_compliment,sketch.width-3100,200)
          //text(input_data.compliment,1000,200)

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // TOP SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
            sketch.rotate(0);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_superpower.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element011_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element011_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element011_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element011_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element011_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element011_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element011_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element011_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element011_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element011_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element011_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element011_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element011_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element011_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element011_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element011_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // RIGHT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
            sketch.rotate(90);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_superpower.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element011_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element011_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element011_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element011_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element011_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element011_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element011_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element011_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element011_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element011_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element011_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element011_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element011_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element011_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element011_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element011_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end
            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 1200, 200)
          //text(splitCounter_2x2,400,400)
          //text(charCounter, 1400, 400)
          //text(output_gender.length, 1600, 600)

          //splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // BOTTOM SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
            sketch.rotate(180);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_superpower.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element011_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element011_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element011_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element011_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element011_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element011_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element011_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element011_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element011_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element011_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element011_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element011_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element011_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element011_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element011_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element011_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 200, 200)
          //text(splitCounter_2x2,600,200)
          //text(charCounter, 400, 400)
          //text(output_gender.length, 600, 600)

          // splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // LEFT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
            sketch.rotate(270);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_superpower.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element011_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element011_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element011_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element011_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element011_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element011_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element011_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element011_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element011_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element011_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element011_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element011_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element011_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element011_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element011_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element011_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_superpower.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element011_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element011_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element011_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element011_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element011_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element011_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element011_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element011_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element011_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element011_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element011_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element011_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element011_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element011_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element011_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element011_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          charCounter = 0;
          splitCounter = 0;

          splitCounter_4x4 = 0;
          splitCounter_3x3 = 0;
          splitCounter_2x2 = 0;
          splitCounter_1x1 = 0;
        }
        break;
      case 6:
        {
          // PERSONALITY

          let output_10 = sketch.transToBinary(input_data.personality, sketch.round(aantalVakjes));
          let splitReference = sketch.calcResponsiv(Math.floor(output_10.length / 4), aantalVakjes);

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          //  text(aantalVakjes,4000,400)

          // TOP SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
            sketch.rotate(0);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element010_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element010_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // RIGHT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
            sketch.rotate(90);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element010_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element010_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end
            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 1200, 200)
          //text(splitCounter_2x2,400,400)
          //text(charCounter, 1400, 400)
          //text(output_gender.length, 1600, 600)

          //splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // BOTTOM SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
            sketch.rotate(180);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element010_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element010_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 200, 200)
          //text(splitCounter_2x2,600,200)
          //text(charCounter, 400, 400)
          //text(output_gender.length, 600, 600)

          // splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // LEFT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
            sketch.rotate(270);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(4, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(3, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "0":
                      sketch.fill(turq_colour);
                      sketch.element010_0(2, x, y, gridBoxSize);

                      break;

                    case "1":
                      sketch.fill(pink_colour);
                      sketch.element010_1(2, x, y, gridBoxSize);
                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "0":
                  sketch.fill(turq_colour);
                  sketch.element010_0(1, 0, 0, gridBoxSize);

                  break;

                case "1":
                  sketch.fill(turq_colour);
                  sketch.element010_1(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }
            sketch.pop();
            // element end

            sketch.pop();
          }

          charCounter = 0;
          splitCounter = 0;

          splitCounter_4x4 = 0;
          splitCounter_3x3 = 0;
          splitCounter_2x2 = 0;
          splitCounter_1x1 = 0;
        }
        break;
      case 5:
        {
          // THIS YEAR

          switch (input_data.thisyear) {
            case thisyear_choices[0]:
              {
                // 'ASIA'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    for (let p = -gridBoxSize / 2 + gridBoxSize / 8; p < gridBoxSize / 2; p += gridBoxSize / 2) {
                      sketch.fill(blue_colour);
                      sketch.rect(0, p, gridBoxSize, gridBoxSize / 4);
                    }
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    for (let p = -gridBoxSize / 2 + gridBoxSize / 8; p < gridBoxSize / 2; p += gridBoxSize / 2) {
                      sketch.fill(turq_colour);
                      sketch.rect(0, p, gridBoxSize, gridBoxSize / 4);
                    }
                  }
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    for (let p = -gridBoxSize / 2 + gridBoxSize / 8; p < gridBoxSize / 2; p += gridBoxSize / 2) {
                      sketch.fill(blue_colour);
                      sketch.rect(0, p, gridBoxSize, gridBoxSize / 4);
                    }
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    for (let p = -gridBoxSize / 2 + gridBoxSize / 8; p < gridBoxSize / 2; p += gridBoxSize / 2) {
                      sketch.fill(turq_colour);
                      sketch.rect(0, p, gridBoxSize, gridBoxSize / 4);
                    }
                  }
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    for (let p = -gridBoxSize / 2 + gridBoxSize / 8; p < gridBoxSize / 2; p += gridBoxSize / 2) {
                      sketch.fill(blue_colour);
                      sketch.rect(0, p, gridBoxSize, gridBoxSize / 4);
                    }
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    for (let p = -gridBoxSize / 2 + gridBoxSize / 8; p < gridBoxSize / 2; p += gridBoxSize / 2) {
                      sketch.fill(turq_colour);
                      sketch.rect(0, p, gridBoxSize, gridBoxSize / 4);
                    }
                  }
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(turq_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    for (let p = -gridBoxSize / 2 + gridBoxSize / 8; p < gridBoxSize / 2; p += gridBoxSize / 2) {
                      sketch.fill(blue_colour);
                      sketch.rect(0, p, gridBoxSize, gridBoxSize / 4);
                    }
                  } else {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    for (let p = -gridBoxSize / 2 + gridBoxSize / 8; p < gridBoxSize / 2; p += gridBoxSize / 2) {
                      sketch.fill(turq_colour);
                      sketch.rect(0, p, gridBoxSize, gridBoxSize / 4);
                    }
                  }
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
              }
              break;
            case thisyear_choices[1]:
              {
                // 'EUROPE'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (sequenceCounter < 2 || drawDot > placeXYplus - 1.5 * gridBoxSize - 1) {
                    if (counter % 2 === 0) {
                      sketch.fill(pink_colour);
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                      sketch.fill(yellow_colour);
                      sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                    } else {
                      sketch.fill(yellow_colour);
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                      sketch.fill(pink_colour);
                      sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                    }
                  } else {
                    if (counter % 2 === 0) {
                      sketch.fill(pink_colour);
                      sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      sketch.fill(yellow_colour);
                      sketch.ellipse(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      drawDot += gridBoxSize;

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);

                      let gradient_yellow_pink_custom = sketch.drawingContext.createLinearGradient(gridBoxSize / 2, 0, 1.5 * gridBoxSize, 0);

                      gradient_yellow_pink_custom.addColorStop(0, sketch.color(pink_colour));
                      gradient_yellow_pink_custom.addColorStop(1, sketch.color(yellow_colour));

                      sketch.drawingContext.fillStyle = gradient_yellow_pink_custom;
                      sketch.rect(gridBoxSize, 0, gridBoxSize, gridBoxSize / 4);
                    } else {
                      sketch.fill(yellow_colour);
                      sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      sketch.fill(pink_colour);
                      sketch.ellipse(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      drawDot += gridBoxSize;

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);

                      let gradient_yellow_pink_custom = sketch.drawingContext.createLinearGradient(gridBoxSize / 2, 0, 1.5 * gridBoxSize, 0);

                      gradient_yellow_pink_custom.addColorStop(0, sketch.color(yellow_colour));
                      gradient_yellow_pink_custom.addColorStop(1, sketch.color(pink_colour));

                      sketch.drawingContext.fillStyle = gradient_yellow_pink_custom;
                      sketch.rect(gridBoxSize, 0, gridBoxSize, gridBoxSize / 4);
                    }
                  }

                  counter++;
                  sequenceCounter++;
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                sequenceCounter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (sequenceCounter < 2 || drawDot > placeXYplus - 1.5 * gridBoxSize - 1) {
                    if (counter % 2 === 0) {
                      sketch.fill(pink_colour);
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                      sketch.fill(yellow_colour);
                      sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                    } else {
                      sketch.fill(yellow_colour);
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                      sketch.fill(pink_colour);
                      sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                    }
                  } else {
                    if (counter % 2 === 0) {
                      sketch.fill(pink_colour);
                      sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      sketch.fill(yellow_colour);
                      sketch.ellipse(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      drawDot += gridBoxSize;

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);

                      let gradient_yellow_pink_custom = sketch.drawingContext.createLinearGradient(gridBoxSize / 2, 0, 1.5 * gridBoxSize, 0);

                      gradient_yellow_pink_custom.addColorStop(0, sketch.color(pink_colour));
                      gradient_yellow_pink_custom.addColorStop(1, sketch.color(yellow_colour));

                      sketch.drawingContext.fillStyle = gradient_yellow_pink_custom;
                      sketch.rect(gridBoxSize, 0, gridBoxSize, gridBoxSize / 4);
                    } else {
                      sketch.fill(yellow_colour);
                      sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      sketch.fill(pink_colour);
                      sketch.ellipse(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);

                      drawDot += gridBoxSize;

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);

                      let gradient_yellow_pink_custom = sketch.drawingContext.createLinearGradient(gridBoxSize / 2, 0, 1.5 * gridBoxSize, 0);

                      gradient_yellow_pink_custom.addColorStop(0, sketch.color(yellow_colour));
                      gradient_yellow_pink_custom.addColorStop(1, sketch.color(pink_colour));

                      sketch.drawingContext.fillStyle = gradient_yellow_pink_custom;
                      sketch.rect(gridBoxSize, 0, gridBoxSize, gridBoxSize / 4);
                    }
                  }

                  counter++;
                  sequenceCounter++;
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                sequenceCounter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (sequenceCounter < 2 || drawDot < placeXYminus + gridBoxSize * 2) {
                    if (counter % 2 === 0) {
                      sketch.fill(pink_colour);
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                      sketch.fill(yellow_colour);
                      sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                    } else {
                      sketch.fill(yellow_colour);
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                      sketch.fill(pink_colour);
                      sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                    }
                  } else {
                    if (counter % 2 === 0) {
                      sketch.fill(pink_colour);
                      sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      sketch.fill(yellow_colour);
                      sketch.ellipse(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      drawDot -= gridBoxSize;

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);

                      let gradient_yellow_pink_custom = sketch.drawingContext.createLinearGradient(gridBoxSize / 2, 0, 1.5 * gridBoxSize, 0);

                      gradient_yellow_pink_custom.addColorStop(0, sketch.color(pink_colour));
                      gradient_yellow_pink_custom.addColorStop(1, sketch.color(yellow_colour));

                      sketch.drawingContext.fillStyle = gradient_yellow_pink_custom;
                      sketch.rect(gridBoxSize, 0, gridBoxSize, gridBoxSize / 4);
                    } else {
                      sketch.fill(yellow_colour);
                      sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      sketch.fill(pink_colour);
                      sketch.ellipse(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      drawDot -= gridBoxSize;

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);

                      let gradient_yellow_pink_custom = sketch.drawingContext.createLinearGradient(gridBoxSize / 2, 0, 1.5 * gridBoxSize, 0);

                      gradient_yellow_pink_custom.addColorStop(0, sketch.color(yellow_colour));
                      gradient_yellow_pink_custom.addColorStop(1, sketch.color(pink_colour));

                      sketch.drawingContext.fillStyle = gradient_yellow_pink_custom;
                      sketch.rect(gridBoxSize, 0, gridBoxSize, gridBoxSize / 4);
                    }
                  }

                  counter++;
                  sequenceCounter++;
                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                sequenceCounter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (sequenceCounter < 2 || drawDot < placeXYminus + gridBoxSize * 2) {
                    if (counter % 2 === 0) {
                      sketch.fill(pink_colour);
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                      sketch.fill(yellow_colour);
                      sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                    } else {
                      sketch.fill(yellow_colour);
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                      sketch.fill(pink_colour);
                      sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);
                    }
                  } else {
                    if (counter % 2 === 0) {
                      sketch.fill(pink_colour);
                      sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      sketch.fill(yellow_colour);
                      sketch.ellipse(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      drawDot -= gridBoxSize;

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);

                      let gradient_yellow_pink_custom = sketch.drawingContext.createLinearGradient(gridBoxSize / 2, 0, 1.5 * gridBoxSize, 0);

                      gradient_yellow_pink_custom.addColorStop(0, sketch.color(pink_colour));
                      gradient_yellow_pink_custom.addColorStop(1, sketch.color(yellow_colour));

                      sketch.drawingContext.fillStyle = gradient_yellow_pink_custom;
                      sketch.rect(gridBoxSize, 0, gridBoxSize, gridBoxSize / 4);
                    } else {
                      sketch.fill(yellow_colour);
                      sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      sketch.fill(pink_colour);
                      sketch.ellipse(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                      drawDot -= gridBoxSize;

                      sketch.drawingContext.fillStyle = gradient_yellow_pink;
                      sketch.rect(0, 0, gridBoxSize, gridBoxSize / 4);

                      let gradient_yellow_pink_custom = sketch.drawingContext.createLinearGradient(gridBoxSize / 2, 0, 1.5 * gridBoxSize, 0);

                      gradient_yellow_pink_custom.addColorStop(0, sketch.color(yellow_colour));
                      gradient_yellow_pink_custom.addColorStop(1, sketch.color(pink_colour));

                      sketch.drawingContext.fillStyle = gradient_yellow_pink_custom;
                      sketch.rect(gridBoxSize, 0, gridBoxSize, gridBoxSize / 4);
                    }
                  }

                  counter++;
                  sequenceCounter++;
                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
                sequenceCounter = 0;
              }
              break;
            case thisyear_choices[2]:
              {
                // 'NORTH-AMERICA'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.scale(flip, flip);

                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();

                  if (counter % 3 === 0) {
                    sketch.fill(orange_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.scale(flip, flip);

                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();

                  if (counter % 3 === 0) {
                    sketch.fill(orange_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }
                counter = 0;
                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.scale(flip, flip);

                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();

                  if (counter % 3 === 0) {
                    sketch.fill(orange_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.push();
                  sketch.scale(flip, flip);

                  sketch.fill(turq_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(brown_colour);
                  sketch.rect(0, gridBoxSize / 4, gridBoxSize, gridBoxSize / 2);

                  sketch.pop();

                  if (counter % 3 === 0) {
                    sketch.fill(orange_colour);
                    sketch.ellipse(0, 0, gridBoxSize, gridBoxSize);
                  }

                  sketch.pop();
                  // element end
                  flip *= -1;
                  counter++;
                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case thisyear_choices[3]:
              {
                // 'OCEANIA'
                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 270, 90);
                  }
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 270, 90);
                  }
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 270, 90);
                  }
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.rotate(0);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(purple_colour);
                    sketch.arc(gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 90, 270);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                    sketch.arc(-gridBoxSize / 2, 0, gridBoxSize, gridBoxSize, 270, 90);
                  }
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case thisyear_choices[4]:
              {
                // 'SOUTH-AMERICA'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (sequenceCounter === 2) {
                    sketch.scale(-1, 1);
                    sequenceCounter = -1;
                  } else {
                    sketch.scale(1, 1);
                  }

                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(pink_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                  sketch.fill(turq_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 270, 90);

                  sketch.pop();
                  sequenceCounter++;

                  // element end

                  sketch.pop();
                }
                sequenceCounter = 0;

                // RIGHT SIDE
                sketch.stroke(brown_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (sequenceCounter === 2) {
                    sketch.scale(-1, 1);
                    sequenceCounter = -1;
                  } else {
                    sketch.scale(1, 1);
                  }

                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(pink_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                  sketch.fill(turq_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 270, 90);

                  sketch.pop();
                  sequenceCounter++;

                  // element end

                  sketch.pop();
                }
                sequenceCounter = 0;

                // BOTTOM SIDE
                sketch.stroke(brown_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (sequenceCounter === 2) {
                    sketch.scale(-1, 1);
                    sequenceCounter = -1;
                  } else {
                    sketch.scale(1, 1);
                  }

                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(pink_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                  sketch.fill(turq_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 270, 90);

                  sketch.pop();
                  sequenceCounter++;

                  // element end

                  sketch.pop();
                }
                sequenceCounter = 0;

                // LEFT SIDE
                sketch.stroke(brown_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (sequenceCounter === 2) {
                    sketch.scale(-1, 1);
                    sequenceCounter = -1;
                  } else {
                    sketch.scale(1, 1);
                  }

                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(pink_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 90, 270);
                  sketch.fill(turq_colour);
                  sketch.arc(0, 0, gridBoxSize, gridBoxSize, 270, 90);

                  sketch.pop();
                  sequenceCounter++;

                  // element end

                  sketch.pop();
                }
                sequenceCounter = 0;
              }
              break;
          }
        }
        break;
      case 4:
        {
          // COMMUTE

          switch (input_data.commute) {
            case commute_choices[0]:
              {
                // 'BIKE'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }
                  sketch.arc(-gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize, gridBoxSize, 0, 90);

                  sketch.pop();
                  rotate90 += 90;
                  counter++;

                  // element end

                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }
                  sketch.arc(-gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize, gridBoxSize, 0, 90);

                  sketch.pop();
                  rotate90 += 90;
                  counter++;

                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }
                  sketch.arc(-gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize, gridBoxSize, 0, 90);

                  sketch.pop();
                  rotate90 += 90;
                  counter++;

                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:

                  sketch.push();

                  sketch.rotate(rotate90);

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(orange_colour);
                  } else {
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }
                  sketch.arc(-gridBoxSize / 4, -gridBoxSize / 4, gridBoxSize, gridBoxSize, 0, 90);

                  sketch.pop();
                  rotate90 += 90;
                  counter++;

                  // element end

                  sketch.pop();
                }
                rotate90 = 0;
                counter = 0;
              }

              break;
            case commute_choices[1]:
              {
                // 'CAR'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  switch (sequenceCounter) {
                    case 0:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 1:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 2:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 3:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 4:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 5:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                  }

                  counter++;

                  if (sequenceCounter === 5) {
                    sequenceCounter = 0;
                  } else {
                    sequenceCounter++;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                sequenceCounter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  switch (sequenceCounter) {
                    case 0:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 1:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 2:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 3:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 4:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 5:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                  }

                  counter++;

                  if (sequenceCounter === 5) {
                    sequenceCounter = 0;
                  } else {
                    sequenceCounter++;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                sequenceCounter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  switch (sequenceCounter) {
                    case 0:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 1:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 2:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 3:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 4:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 5:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                  }

                  counter++;

                  if (sequenceCounter === 5) {
                    sequenceCounter = 0;
                  } else {
                    sequenceCounter++;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                sequenceCounter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(pink_colour);
                  } else {
                    sketch.fill(pink_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  }

                  switch (sequenceCounter) {
                    case 0:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 1:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 2:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 3:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 4:
                      {
                        sketch.ellipse(-0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                    case 5:
                      {
                        sketch.ellipse(0.25 * gridBoxSize, 0, gridBoxSize / 2, gridBoxSize / 2);
                      }
                      break;
                  }

                  counter++;

                  if (sequenceCounter === 5) {
                    sequenceCounter = 0;
                  } else {
                    sequenceCounter++;
                  }

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
                sequenceCounter = 0;
              }
              break;
            case commute_choices[2]:
              {
                // 'PUBLIC TRAINSPORT'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.scale(flip, 1);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 8, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2); //
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 8);

                    sketch.endShape();

                    sketch.fill(brown_colour);

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2); //
                    sketch.vertex(gridBoxSize / 8, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 8);

                    sketch.endShape();

                    if (flip === -1) {
                      flip = 1;
                    } else {
                      flip = -1;
                    }

                    sketch.pop();
                  } else {
                    sketch.drawingContext.fillStyle = gradient_yellow_white;

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                flip = 1;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.scale(flip, 1);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 8, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2); //
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 8);

                    sketch.endShape();

                    sketch.fill(brown_colour);

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2); //
                    sketch.vertex(gridBoxSize / 8, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 8);

                    sketch.endShape();

                    if (flip === -1) {
                      flip = 1;
                    } else {
                      flip = -1;
                    }

                    sketch.pop();
                  } else {
                    sketch.drawingContext.fillStyle = gradient_yellow_white;

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                flip = 1;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.scale(flip, 1);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 8, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2); //
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 8);

                    sketch.endShape();

                    sketch.fill(brown_colour);

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2); //
                    sketch.vertex(gridBoxSize / 8, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 8);

                    sketch.endShape();

                    if (flip === -1) {
                      flip = 1;
                    } else {
                      flip = -1;
                    }

                    sketch.pop();
                  } else {
                    sketch.drawingContext.fillStyle = gradient_yellow_white;

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                flip = 1;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.push();

                    sketch.scale(flip, 1);
                    sketch.fill(orange_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(blue_colour);
                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 8, -gridBoxSize / 2);
                    sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2); //
                    sketch.vertex(gridBoxSize / 2, gridBoxSize / 8);

                    sketch.endShape();

                    sketch.fill(brown_colour);

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2); //
                    sketch.vertex(gridBoxSize / 8, gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 8);

                    sketch.endShape();

                    if (flip === -1) {
                      flip = 1;
                    } else {
                      flip = -1;
                    }

                    sketch.pop();
                  } else {
                    sketch.drawingContext.fillStyle = gradient_yellow_white;

                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                flip = 1;
              }

              break;
            case commute_choices[3]:
              {
                // 'WALK'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  let a;
                  let b;

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                    a = brown_colour;
                    b = orange_colour;
                  } else {
                    a = orange_colour;
                    b = brown_colour;
                  }

                  sketch.fill(a);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(b);
                  sketch.rect(-gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3);
                  sketch.rect(gridBoxSize / 3, -gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3);
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  let a;
                  let b;

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                    a = brown_colour;
                    b = orange_colour;
                  } else {
                    a = orange_colour;
                    b = brown_colour;
                  }

                  sketch.fill(a);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(b);
                  sketch.rect(-gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3);
                  sketch.rect(gridBoxSize / 3, -gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3);
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  let a;
                  let b;

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                    a = brown_colour;
                    b = orange_colour;
                  } else {
                    a = orange_colour;
                    b = brown_colour;
                  }

                  sketch.fill(a);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(b);
                  sketch.rect(-gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3);
                  sketch.rect(gridBoxSize / 3, -gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3);
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  let a;
                  let b;
                  
                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                    a = brown_colour;
                    b = orange_colour;
                  } else {
                    a = orange_colour;
                    b = brown_colour;
                  }

                  sketch.fill(a);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(b);
                  sketch.rect(-gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3);
                  sketch.rect(gridBoxSize / 3, -gridBoxSize / 3, gridBoxSize / 3, gridBoxSize / 3);
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case commute_choices[4]:
              {
                // 'MOTORCYCLE'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  }

                  sketch.rotate(70.5 + 90);
                  sketch.rect(0, 0, gridBoxSize * 0.95, gridBoxSize / 3);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  }

                  sketch.rotate(70.5 + 90);
                  sketch.rect(0, 0, gridBoxSize * 0.95, gridBoxSize / 3);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  }

                  sketch.rotate(70.5 + 90);
                  sketch.rect(0, 0, gridBoxSize * 0.95, gridBoxSize / 3);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(blue_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(yellow_colour);
                  } else {
                    sketch.fill(yellow_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                    sketch.fill(blue_colour);
                  }

                  sketch.rotate(70.5 + 90);
                  sketch.rect(0, 0, gridBoxSize * 0.95, gridBoxSize / 3);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case commute_choices[5]:
              {
                // 'MOTOR SCOOTER / MOPED'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (counter % 2 === 0) {
                    sketch.scale(1, -1);
                  }
                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, 0);
                  sketch.vertex(0, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, 0);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (counter % 2 === 0) {
                    sketch.scale(1, -1);
                  }
                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, 0);
                  sketch.vertex(0, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, 0);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (counter % 2 === 0) {
                    sketch.scale(1, -1);
                  }
                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, 0);
                  sketch.vertex(0, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, 0);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (counter % 2 === 0) {
                    sketch.scale(1, -1);
                  }
                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, 0);
                  sketch.vertex(0, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, 0);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();
                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case commute_choices[6]:
              {
                // 'UBER / TAXI'
                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                  }
                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(0, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                  }
                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(0, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                  }
                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(0, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.fill(yellow_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  if (counter % 2 === 0) {
                    sketch.scale(-1, 1);
                  }
                  sketch.fill(turq_colour);

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(0, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 6, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();
                  // element end
                  counter++;

                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case commute_choices[7]:
              {
                // 'MOBILITY AID'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);

                  if (counter % 2 === 0) {
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  } else {
                    sketch.rotate(-90);
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  sketch.push();

                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);

                  if (counter % 2 === 0) {
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  } else {
                    sketch.rotate(-90);
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  sketch.push();

                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);

                  if (counter % 2 === 0) {
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  } else {
                    sketch.rotate(-90);
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  sketch.push();

                  sketch.fill(orange_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(brown_colour);

                  if (counter % 2 === 0) {
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  } else {
                    sketch.rotate(-90);
                    sketch.beginShape();
                    sketch.vertex(-0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, 0.5 * gridBoxSize);
                    sketch.vertex(0.5 * gridBoxSize, -0.5 * gridBoxSize);
                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;
              }
              break;
            case commute_choices[8]:
              {
                // 'SKATE'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(purple_colour);
                  sketch.beginShape();

                  sketch.vertex(0, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, 0); //
                  sketch.vertex(-gridBoxSize / 4, 0);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2); //
                  sketch.vertex(0, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, 0);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2); //
                  sketch.vertex(-gridBoxSize / 4, 0);
                  sketch.vertex(0, gridBoxSize / 2);

                  sketch.endShape();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2); //
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 4, 0);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 4, 0); //
                    sketch.vertex(gridBoxSize / 4, 0);
                    sketch.vertex(0, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(purple_colour);
                  sketch.beginShape();

                  sketch.vertex(0, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, 0); //
                  sketch.vertex(-gridBoxSize / 4, 0);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2); //
                  sketch.vertex(0, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, 0);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2); //
                  sketch.vertex(-gridBoxSize / 4, 0);
                  sketch.vertex(0, gridBoxSize / 2);

                  sketch.endShape();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2); //
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 4, 0);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 4, 0); //
                    sketch.vertex(gridBoxSize / 4, 0);
                    sketch.vertex(0, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(purple_colour);
                  sketch.beginShape();

                  sketch.vertex(0, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, 0); //
                  sketch.vertex(-gridBoxSize / 4, 0);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2); //
                  sketch.vertex(0, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, 0);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2); //
                  sketch.vertex(-gridBoxSize / 4, 0);
                  sketch.vertex(0, gridBoxSize / 2);

                  sketch.endShape();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2); //
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 4, 0);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 4, 0); //
                    sketch.vertex(gridBoxSize / 4, 0);
                    sketch.vertex(0, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                  sketch.fill(purple_colour);
                  sketch.beginShape();

                  sketch.vertex(0, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, 0); //
                  sketch.vertex(-gridBoxSize / 4, 0);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2); //
                  sketch.vertex(0, gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 4, 0);

                  sketch.endShape();

                  sketch.beginShape();

                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2); //
                  sketch.vertex(-gridBoxSize / 4, 0);
                  sketch.vertex(0, gridBoxSize / 2);

                  sketch.endShape();

                  if (counter % 2 === 0) {
                    sketch.fill(orange_colour);

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 2, -gridBoxSize / 2); //
                    sketch.vertex(0, -gridBoxSize / 2);
                    sketch.vertex(-gridBoxSize / 4, 0);

                    sketch.endShape();

                    sketch.beginShape();

                    sketch.vertex(-gridBoxSize / 4, 0); //
                    sketch.vertex(gridBoxSize / 4, 0);
                    sketch.vertex(0, gridBoxSize / 2);

                    sketch.endShape();
                  }

                  counter++;

                  sketch.pop();
                  // element end

                  sketch.pop();
                }

                counter = 0;
              }

              break;
            case commute_choices[9]:
              {
                // 'OTHER'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  if (drawDot === placeXYminus + 0.5 * gridBoxSize) {
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  } else if (counter % 2 !== 0) {
                    sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                  }
                  sketch.fill(purple_colour);
                  sketch.rotate(15);
                  sketch.rect(0, 0, gridBoxSize * 0.81, gridBoxSize * 0.81);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  if (drawDot === placeXYminus + 0.5 * gridBoxSize) {
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  } else if (counter % 2 !== 0) {
                    sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                  }
                  sketch.fill(purple_colour);
                  sketch.rotate(15);
                  sketch.rect(0, 0, gridBoxSize * 0.81, gridBoxSize * 0.81);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  if (drawDot === placeXYplus - 0.5 * gridBoxSize) {
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  } else if (counter % 2 !== 0) {
                    sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                  }
                  sketch.fill(purple_colour);
                  sketch.rotate(15);
                  sketch.rect(0, 0, gridBoxSize * 0.81, gridBoxSize * 0.81);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }

                counter = 0;
                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.drawingContext.fillStyle = gradient_yellow_turq;
                  if (drawDot === placeXYplus - 0.5 * gridBoxSize) {
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  } else if (counter % 2 !== 0) {
                    sketch.rect(gridBoxSize / 2, 0, gridBoxSize * 2, gridBoxSize);
                  }
                  sketch.fill(purple_colour);
                  sketch.rotate(15);
                  sketch.rect(0, 0, gridBoxSize * 0.81, gridBoxSize * 0.81);

                  sketch.pop();
                  // element end
                  counter++;
                  sketch.pop();
                }
                counter = 0;
              }

              break;
          }
        }
        break;
      case 3:
        {
          // FEAR

          let output_10 = sketch.transToBinaryShort_X2(input_data.fear, sketch.round(aantalVakjes));
          let splitReference = sketch.calcResponsiv(Math.floor(output_10.length / 4), aantalVakjes);

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // TOP SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
            sketch.rotate(0);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element012_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element012_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element012_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element012_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element012_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element012_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element012_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element012_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element012_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element012_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element012_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element012_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element012_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element012_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element012_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element012_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // RIGHT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
            sketch.rotate(90);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element012_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element012_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element012_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element012_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element012_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element012_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element012_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element012_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element012_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element012_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element012_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element012_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element012_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element012_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element012_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element012_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end
            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 1200, 200)
          //text(splitCounter_2x2,400,400)
          //text(charCounter, 1400, 400)
          //text(output_gender.length, 1600, 600)

          //splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // BOTTOM SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
            sketch.rotate(180);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element012_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element012_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element012_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element012_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element012_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element012_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element012_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element012_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element012_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element012_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element012_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element012_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element012_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element012_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element012_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element012_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 200, 200)
          //text(splitCounter_2x2,600,200)
          //text(charCounter, 400, 400)
          //text(output_gender.length, 600, 600)

          // splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // LEFT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
            sketch.rotate(270);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element012_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element012_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element012_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element012_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element012_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element012_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element012_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element012_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element012_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element012_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element012_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element012_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element012_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element012_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element012_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element012_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element012_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element012_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element012_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element012_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element012_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element012_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element012_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element012_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element012_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element012_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element012_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element012_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element012_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element012_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element012_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element012_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          charCounter = 0;
          splitCounter = 0;

          splitCounter_4x4 = 0;
          splitCounter_3x3 = 0;
          splitCounter_2x2 = 0;
          splitCounter_1x1 = 0;
        }
        break;
      case 2:
        {
          // MEMORY

          let output_10 = sketch.transToBinaryShort_X2(input_data.memory, sketch.round(aantalVakjes));
          let splitReference = sketch.calcResponsiv(Math.floor(output_10.length / 4), aantalVakjes);

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // TOP SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
            sketch.rotate(0);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element015_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element015_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element015_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element015_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element015_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element015_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element015_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element015_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element015_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element015_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element015_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element015_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element015_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element015_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element015_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element015_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // RIGHT SIDE
          sketch.stroke(purple_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
            sketch.rotate(90);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element015_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element015_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element015_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element015_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element015_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element015_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element015_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element015_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element015_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element015_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element015_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element015_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element015_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element015_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element015_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element015_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end
            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 1200, 200)
          //text(splitCounter_2x2,400,400)
          //text(charCounter, 1400, 400)
          //text(output_gender.length, 1600, 600)

          //splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // BOTTOM SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
            sketch.rotate(180);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element015_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element015_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element015_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element015_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element015_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element015_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element015_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element015_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element015_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element015_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element015_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element015_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element015_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element015_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element015_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element015_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 200, 200)
          //text(splitCounter_2x2,600,200)
          //text(charCounter, 400, 400)
          //text(output_gender.length, 600, 600)

          // splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // LEFT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
            sketch.rotate(270);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element015_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element015_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element015_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element015_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element015_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element015_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element015_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element015_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element015_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element015_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element015_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element015_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element015_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element015_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element015_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element015_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element015_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element015_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element015_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element015_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element015_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element015_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element015_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element015_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element015_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element015_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element015_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element015_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element015_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element015_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element015_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element015_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          charCounter = 0;
          splitCounter = 0;

          splitCounter_4x4 = 0;
          splitCounter_3x3 = 0;
          splitCounter_2x2 = 0;
          splitCounter_1x1 = 0;
        }
        break;
      case 1:
        {
          // TIME TRAVEL

          switch (input_data.time_travel) {
            case time_travel_choices[0]:
              {
                // 'TO THE FUTURE'

                // TOP SIDE
                sketch.stroke(pink_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 4 === 0) {
                    sketch.rotate(90);
                  } else if (counter % 4 === 1) {
                    sketch.rotate(-90);
                  } else if (counter % 4 === 2) {
                    sketch.rotate(0);
                  } else {
                    sketch.rotate(180);
                  }

                  sketch.fill(pink_colour);
                  sketch.drawingContext.fillStyle = gradient_orange_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  // sketch.pop();

                  sketch.rotate(rotate90);
                  sketch.fill(yellow_colour);

                  sketch.beginShape();
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.endShape(sketch.CLOSE);

                  // sketch.pop();
                  sketch.pop();
                  // element end
                  rotate90 -= 90;
                  counter++;
                  sketch.pop();
                }
                rotate90 = 0;
                counter = 0;

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 4 === 0) {
                    sketch.rotate(90);
                  } else if (counter % 4 === 1) {
                    sketch.rotate(-90);
                  } else if (counter % 4 === 2) {
                    sketch.rotate(0);
                  } else {
                    sketch.rotate(180);
                  }

                  sketch.fill(pink_colour);
                  sketch.drawingContext.fillStyle = gradient_orange_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  // sketch.pop();

                  sketch.rotate(rotate90);
                  sketch.fill(yellow_colour);

                  sketch.beginShape();
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.endShape(sketch.CLOSE);

                  // sketch.pop();
                  sketch.pop();
                  // element end
                  rotate90 -= 90;
                  counter++;
                  sketch.pop();
                }
                rotate90 = 0;
                counter = 0;

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 4 === 0) {
                    sketch.rotate(90);
                  } else if (counter % 4 === 1) {
                    sketch.rotate(-90);
                  } else if (counter % 4 === 2) {
                    sketch.rotate(0);
                  } else {
                    sketch.rotate(180);
                  }

                  sketch.fill(pink_colour);
                  sketch.drawingContext.fillStyle = gradient_orange_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  // sketch.pop();

                  sketch.rotate(rotate90);
                  sketch.fill(yellow_colour);

                  sketch.beginShape();
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.endShape(sketch.CLOSE);

                  // sketch.pop();
                  sketch.pop();
                  // element end
                  rotate90 -= 90;
                  counter++;
                  sketch.pop();
                }
                rotate90 = 0;
                counter = 0;

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 4 === 0) {
                    sketch.rotate(90);
                  } else if (counter % 4 === 1) {
                    sketch.rotate(-90);
                  } else if (counter % 4 === 2) {
                    sketch.rotate(0);
                  } else {
                    sketch.rotate(180);
                  }

                  sketch.fill(pink_colour);
                  sketch.drawingContext.fillStyle = gradient_orange_pink;
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  // sketch.pop();

                  sketch.rotate(rotate90);
                  sketch.fill(yellow_colour);

                  sketch.beginShape();
                  sketch.vertex(gridBoxSize / 2, -gridBoxSize / 2);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 2);
                  sketch.endShape(sketch.CLOSE);

                  // sketch.pop();
                  sketch.pop();
                  // element end
                  rotate90 -= 90;
                  counter++;
                  sketch.pop();
                }
                rotate90 = 0;
                counter = 0;
              }

              break;
            case time_travel_choices[1]:
              {
                // 'TO THE PAST'

                // TOP SIDE
                sketch.stroke(brown_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_turq_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(purple_colour);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_turq_white;
                  }

                  sketch.rotate(45);
                  sketch.rect(0, 0, gridBoxSize * 0.7, gridBoxSize * 0.7);

                  sketch.pop();
                  // element end

                  counter++;
                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_turq_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(purple_colour);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_turq_white;
                  }

                  sketch.rotate(45);
                  sketch.rect(0, 0, gridBoxSize * 0.7, gridBoxSize * 0.7);

                  sketch.pop();
                  // element end

                  counter++;
                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_turq_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(purple_colour);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_turq_white;
                  }

                  sketch.rotate(45);
                  sketch.rect(0, 0, gridBoxSize * 0.7, gridBoxSize * 0.7);

                  sketch.pop();
                  // element end

                  counter++;
                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();

                  if (counter % 2 === 0) {
                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_turq_white;
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(purple_colour);
                  } else {
                    sketch.fill(purple_colour);
                    sketch.rect(0, 0, gridBoxSize, gridBoxSize);

                    sketch.fill(yellow_colour);
                    sketch.drawingContext.fillStyle = gradient_turq_white;
                  }

                  sketch.rotate(45);
                  sketch.rect(0, 0, gridBoxSize * 0.7, gridBoxSize * 0.7);

                  sketch.pop();
                  // element end

                  counter++;
                  sketch.pop();
                }

                counter = 0;
              }

              break;
            case time_travel_choices[2]:
              {
                // 'STAY HERE'

                // TOP SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
                  sketch.rotate(0);

                  // element begin:
                  sketch.push();
                  sketch.rotate(90);

                  sketch.fill(purple_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(orange_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 5, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 5);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();

                  // element end
                  sketch.pop();
                }

                // RIGHT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(90);

                  // element begin:
                  sketch.push();
                  sketch.rotate(90);

                  sketch.fill(purple_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(orange_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 5, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 5);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();

                  // element end

                  sketch.pop();
                }

                // BOTTOM SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
                  sketch.rotate(180);

                  // element begin:
                  sketch.push();
                  sketch.rotate(90);

                  sketch.fill(purple_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(orange_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 5, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 5);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();

                  // element end

                  sketch.pop();
                }

                // LEFT SIDE
                sketch.stroke(purple_colour);
                sketch.strokeCap(sketch.SQUARE);
                sketch.strokeWeight(gridBoxSize);
                sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
                sketch.noStroke();

                for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
                  sketch.push();

                  sketch.fill(brown_colour);
                  sketch.noStroke();
                  sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
                  sketch.rotate(270);

                  // element begin:
                  sketch.push();
                  sketch.rotate(90);

                  sketch.fill(purple_colour);
                  sketch.rect(0, 0, gridBoxSize, gridBoxSize);
                  sketch.fill(orange_colour);

                  sketch.beginShape();

                  sketch.vertex(gridBoxSize / 5, -gridBoxSize / 2);
                  sketch.vertex(-gridBoxSize / 2, gridBoxSize / 5);
                  sketch.vertex(gridBoxSize / 2, gridBoxSize / 2);

                  sketch.endShape();

                  sketch.pop();

                  // element end

                  sketch.pop();
                }
                counter = 0;
              }

              break;
          }
        }
        break;
      case 0:
        {
          // PROUD

          let output_10 = sketch.transToBinaryShort_X2(input_data.proud, sketch.round(aantalVakjes));
          let splitReference = sketch.calcResponsiv(Math.floor(output_10.length / 4), aantalVakjes);

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          /*        text(sketch.round(aantalVakjes),5500,400)
     text(myRectSize,4000,500)
     text(gridBoxSize,4900,400)
*/

          // TOP SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus, placeXYminus + 0.5 * gridBoxSize, placeXYplus - gridBoxSize, placeXYminus + 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYminus + 0.5 * gridBoxSize);
            sketch.rotate(0);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element014_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element014_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element014_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element014_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element014_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element014_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element014_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element014_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element014_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element014_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element014_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element014_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element014_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element014_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element014_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element014_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // RIGHT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus - 0.5 * gridBoxSize, placeXYminus, placeXYplus - 0.5 * gridBoxSize, placeXYplus - gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYminus + 0.5 * gridBoxSize; drawDot <= placeXYplus - 1.5 * gridBoxSize + 1; drawDot += gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYplus - 0.5 * gridBoxSize, drawDot);
            sketch.rotate(90);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element014_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element014_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element014_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element014_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element014_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element014_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element014_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element014_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element014_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element014_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element014_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element014_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element014_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element014_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element014_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element014_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end
            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 1200, 200)
          //text(splitCounter_2x2,400,400)
          //text(charCounter, 1400, 400)
          //text(output_gender.length, 1600, 600)

          //splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // BOTTOM SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYplus, placeXYplus - 0.5 * gridBoxSize, placeXYminus + gridBoxSize, placeXYplus - 0.5 * gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(drawDot, placeXYplus - 0.5 * gridBoxSize);
            sketch.rotate(180);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element014_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element014_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element014_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element014_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element014_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element014_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element014_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element014_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element014_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element014_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element014_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element014_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element014_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element014_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element014_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element014_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }

            sketch.pop();
            // element end

            sketch.pop();
          }

          sketch.fill("white");
          sketch.textSize(100);
          //text(split_2x2, 200, 200)
          //text(splitCounter_2x2,600,200)
          //text(charCounter, 400, 400)
          //text(output_gender.length, 600, 600)

          // splitCounter = aantalSplitVakjes;

          splitCounter_4x4 = splitReference[3];
          splitCounter_3x3 = splitReference[2];
          splitCounter_2x2 = splitReference[1];
          splitCounter_1x1 = splitReference[0];

          // LEFT SIDE
          sketch.stroke(brown_colour);
          sketch.strokeCap(sketch.SQUARE);
          sketch.strokeWeight(gridBoxSize);
          sketch.line(placeXYminus + 0.5 * gridBoxSize, placeXYplus, placeXYminus + 0.5 * gridBoxSize, placeXYminus + gridBoxSize);
          sketch.noStroke();

          for (let drawDot = placeXYplus - 0.5 * gridBoxSize; drawDot >= placeXYminus + gridBoxSize; drawDot -= gridBoxSize) {
            sketch.push();

            sketch.fill(brown_colour);
            sketch.noStroke();
            sketch.translate(placeXYminus + 0.5 * gridBoxSize, drawDot);
            sketch.rotate(270);

            // element begin:
            sketch.push();

            sketch.fill(brown_colour);
            sketch.rect(0, 0, gridBoxSize, gridBoxSize);
            sketch.fill(pink_colour);

            if (splitCounter_4x4 > 0) {
              for (x = (-gridBoxSize / 8) * 3; x < gridBoxSize - (gridBoxSize / 8) * 3 - 1; x += gridBoxSize / 4) {
                for (y = (-gridBoxSize / 8) * 3; y < gridBoxSize - (gridBoxSize / 8) * 3 - 1; y += gridBoxSize / 4) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(4, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(4, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(4, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(4, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(4, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(4, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(4, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(4, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(4, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(4, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(4, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(4, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(4, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(4, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(4, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(4, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_4x4 -= responsiveness[3].value;
            } else if (splitCounter_3x3 > 0) {
              for (x = -gridBoxSize / 3; x < gridBoxSize - gridBoxSize / 3; x += gridBoxSize / 3) {
                for (y = -gridBoxSize / 3; y < gridBoxSize - gridBoxSize / 3; y += gridBoxSize / 3) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(3, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(3, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(3, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(3, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(3, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(3, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(3, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(3, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(3, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(3, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(3, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(3, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(3, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(3, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(3, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(3, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_3x3 -= responsiveness[2].value;
            } else if (splitCounter_2x2 > 0) {
              for (x = -gridBoxSize / 4; x < gridBoxSize - gridBoxSize / 4; x += gridBoxSize / 2) {
                for (y = -gridBoxSize / 4; y < gridBoxSize - gridBoxSize / 4; y += gridBoxSize / 2) {
                  switch (output_10.charAt(charCounter)) {
                    case "#":
                      sketch.fill(turq_colour);
                      sketch.element014_0(2, x, y, gridBoxSize);

                      break;

                    case "@":
                      sketch.fill(turq_colour);
                      sketch.element014_1(2, x, y, gridBoxSize);

                      break;

                    case "!":
                      sketch.fill(turq_colour);
                      sketch.element014_2(2, x, y, gridBoxSize);

                      break;

                    case "&":
                      sketch.fill(turq_colour);
                      sketch.element014_3(2, x, y, gridBoxSize);

                      break;

                    case "*":
                      sketch.fill(turq_colour);
                      sketch.element014_4(2, x, y, gridBoxSize);

                      break;

                    case "€":
                      sketch.fill(turq_colour);
                      sketch.element014_5(2, x, y, gridBoxSize);

                      break;

                    case "+":
                      sketch.fill(turq_colour);
                      sketch.element014_6(2, x, y, gridBoxSize);

                      break;

                    case "_":
                      sketch.fill(turq_colour);
                      sketch.element014_7(2, x, y, gridBoxSize);

                      break;

                    case "^":
                      sketch.fill(turq_colour);
                      sketch.element014_8(2, x, y, gridBoxSize);

                      break;

                    case "¡":
                      sketch.fill(turq_colour);
                      sketch.element014_9(2, x, y, gridBoxSize);

                      break;

                    case "∞":
                      sketch.fill(turq_colour);
                      sketch.element014_10(2, x, y, gridBoxSize);

                      break;

                    case "•":
                      sketch.fill(turq_colour);
                      sketch.element014_11(2, x, y, gridBoxSize);

                      break;

                    case "£":
                      sketch.fill(turq_colour);
                      sketch.element014_12(2, x, y, gridBoxSize);

                      break;

                    case "¢":
                      sketch.fill(turq_colour);
                      sketch.element014_13(2, x, y, gridBoxSize);

                      break;

                    case ")":
                      sketch.fill(turq_colour);
                      sketch.element014_14(2, x, y, gridBoxSize);

                      break;

                    case "(":
                      sketch.fill(turq_colour);
                      sketch.element014_15(2, x, y, gridBoxSize);

                      break;
                  }

                  charCounter++;
                }
              }

              splitCounter_2x2 -= responsiveness[1].value;
            } else if (splitCounter_1x1 > 0) {
              switch (output_10.charAt(charCounter)) {
                case "#":
                  sketch.fill(turq_colour);
                  sketch.element014_0(1, 0, 0, gridBoxSize);

                  break;

                case "@":
                  sketch.fill(turq_colour);
                  sketch.element014_1(1, 0, 0, gridBoxSize);

                  break;

                case "!":
                  sketch.fill(turq_colour);
                  sketch.element014_2(1, 0, 0, gridBoxSize);

                  break;

                case "&":
                  sketch.fill(turq_colour);
                  sketch.element014_3(1, 0, 0, gridBoxSize);

                  break;

                case "*":
                  sketch.fill(turq_colour);
                  sketch.element014_4(1, 0, 0, gridBoxSize);

                  break;

                case "€":
                  sketch.fill(turq_colour);
                  sketch.element014_5(1, 0, 0, gridBoxSize);

                  break;

                case "+":
                  sketch.fill(turq_colour);
                  sketch.element014_6(1, 0, 0, gridBoxSize);

                  break;

                case "_":
                  sketch.fill(turq_colour);
                  sketch.element014_7(1, 0, 0, gridBoxSize);

                  break;

                case "^":
                  sketch.fill(turq_colour);
                  sketch.element014_8(1, 0, 0, gridBoxSize);

                  break;

                case "¡":
                  sketch.fill(turq_colour);
                  sketch.element014_9(1, 0, 0, gridBoxSize);

                  break;

                case "∞":
                  sketch.fill(turq_colour);
                  sketch.element014_10(1, 0, 0, gridBoxSize);

                  break;

                case "•":
                  sketch.fill(turq_colour);
                  sketch.element014_11(1, 0, 0, gridBoxSize);

                  break;

                case "£":
                  sketch.fill(turq_colour);
                  sketch.element014_12(1, 0, 0, gridBoxSize);

                  break;

                case "¢":
                  sketch.fill(turq_colour);
                  sketch.element014_13(1, 0, 0, gridBoxSize);

                  break;

                case ")":
                  sketch.fill(turq_colour);
                  sketch.element014_14(1, 0, 0, gridBoxSize);

                  break;

                case "(":
                  sketch.fill(turq_colour);
                  sketch.element014_15(1, 0, 0, gridBoxSize);

                  break;
              }
              charCounter++;
              splitCounter_1x1 -= responsiveness[0].value;
            }
            sketch.pop();
            // element end

            sketch.pop();
          }

          charCounter = 0;
          splitCounter = 0;

          splitCounter_4x4 = 0;
          splitCounter_3x3 = 0;
          splitCounter_2x2 = 0;
          splitCounter_1x1 = 0;
        }
        break;
    }
  }


        p5Instance.textureNeedsUpdate = true;

        // Set the flag to true after first draw
        if (!p5InstanceReady) {
          p5InstanceReady = true;
          checkIfReady();
        }

      }

      EventEmitter.subscribe('updateData', (newData) => {
        input_data.first_name = newData.first_name;
        input_data.last_name = newData.last_name;
        input_data.age = newData.age;

        input_data.gender = newData.gender;
        input_data.gender_selfdescribe = newData.gender_selfdescribe;
        input_data.eye_colour = newData.eye_colour;
        input_data.music = newData.music;
        input_data.music_selfdescribe = newData.music_selfdescribe;
        input_data.living = newData.living;
        input_data.time = newData.time;
        input_data.time_selfdescribe = newData.time_selfdescribe;
        input_data.compliment = newData.compliment;
        input_data.intro_extro = newData.intro_extro;
        input_data.reck_caut = newData.reck_caut;
        input_data.superpower = newData.superpower;
        input_data.personality = newData.personality;
        input_data.thisyear = newData.thisyear;
        input_data.commute = newData.commute;
        input_data.commute_selfdescribe = newData.commute_selfdescribe;
        input_data.fear = newData.fear;
        input_data.memory = newData.memory;
        input_data.time_travel = newData.time_travel;
        input_data.proud = newData.proud;

        sketch.redraw();
      });

      // usability

sketch.calcResponsiv = function(CharPerStroke, amountOfBoxes) {
  let split_1x1 = 0;
  let split_2x2 = 0;
  let split_3x3 = 0;
  let split_4x4 = 0;
  let verschil;

  // kleiner of gelijk aan 1x1
  if (CharPerStroke / responsiveness[0].value <= amountOfBoxes) {
    //dan gewoon tekenen
    split_1x1 = amountOfBoxes * responsiveness[0].value;
  }

  //tussen 1x1 en 2x2
  else if (CharPerStroke / responsiveness[0].value > amountOfBoxes && CharPerStroke / responsiveness[1].value < amountOfBoxes) {
    // berekenen hoeveel

    verschil = CharPerStroke - responsiveness[0].value * amountOfBoxes;
    split_2x2 = Math.floor(verschil / (responsiveness[1].value - responsiveness[0].value)) * responsiveness[1].value;
    split_1x1 = CharPerStroke - split_2x2;
  }

  // 2x2
  else if (CharPerStroke / responsiveness[1].value === amountOfBoxes) {
    split_2x2 = amountOfBoxes * responsiveness[1].value;
  }

  //tussen 2x2 en 3x3
  else if (CharPerStroke / responsiveness[1].value > amountOfBoxes && CharPerStroke / responsiveness[2].value < amountOfBoxes) {
    // berekenen hoeveel

    verschil = CharPerStroke - responsiveness[1].value * amountOfBoxes;
    split_3x3 = Math.floor(verschil / (responsiveness[2].value - responsiveness[1].value)) * responsiveness[2].value;
    split_2x2 = CharPerStroke - split_3x3;
  }

  // 3x3
  else if (CharPerStroke / responsiveness[2].value === amountOfBoxes) {
    split_3x3 = amountOfBoxes * responsiveness[2].value;
  }

  //tussen 3x3 en 4x4
  else if (CharPerStroke / responsiveness[2].value > amountOfBoxes && CharPerStroke / responsiveness[3].value < amountOfBoxes) {
    // berekenen hoeveel

    verschil = CharPerStroke - responsiveness[2].value * amountOfBoxes;
    split_4x4 = Math.floor(verschil / (responsiveness[3].value - responsiveness[2].value)) * responsiveness[3].value;
    split_3x3 = CharPerStroke - split_4x4;
  }

  // groter of gelijk aan 4x4
  else if (CharPerStroke / responsiveness[3].value >= amountOfBoxes) {
    // dan gewoon tekenen
    split_4x4 = amountOfBoxes * responsiveness[3].value;
  }

  //return [split_1x1, split_2x2, split_3x3, split_4x4] // this is default :)
  return [CharPerStroke, 0, 0, 0]; // only big ones
}

sketch.transToBinary = function(input, min_elementCount) {
  // Maak een lege string om de binary-representatie op te slaan
  input = (input ?? "").toString(); // ✅ guard against undefined/null
  let output = "";

  // Ga door elk karakter in de input-string
  for (let i = 0; i < input.length; i++) {
    // Converteer het karakter naar binary-representatie en sla het op in de output-string
    output += input[i].charCodeAt(0).toString(2); //+ " ";
  }

  let addOutput = "";

  if (output !== "" && output.length - 1 < min_elementCount * 4) {
    whatever: for (let a = 0; output.length - 1 + addOutput.length - 1 <= min_elementCount * 4; a++) {
      for (let i = 0; i < min_elementCount * 4 - (output.length - 1); i++) {
        addOutput += output.substr(i, 1);
        if (output.length - 1 + addOutput.length - 1 === min_elementCount * 4) {
          break whatever;
        }
      }
    }
  }

  output += addOutput;

  // Geef de output-string terug
  return output;
}

sketch.transToBinaryShort_X2 = function(input, min_elementCount) {
  input = (input ?? "").toString(); // ✅ guard against undefined/null
  let output = [];

  for (let i = 0; i < input.length; i++) {
    let bin = input[i].charCodeAt().toString(2);
    output.push(Array(8 - bin.length + 1).join("0") + bin);
  }

  let newOutput = output.join("");

  let newNewOutput = replaceDigits(newOutput);

  //

  function replaceDigits(str) {
    const replacements = {
      "0000": "#",
      1111: "@",
      1000: "!",
      "0001": "&",
      1100: "*",
      "0011": "€",
      1110: "+",
      "0111": "_",
      "0100": "^",
      "0010": "¡",
      "0110": "∞",
      1001: "•",
      1010: "£",
      "0101": "¢",
      1011: ")",
      1101: "(",
    };

    let result = "";
    const length = str.length;

    for (let a = 0; a < length; a += 4) {
      const substring = str.substr(a, 4);
      result += replacements[substring] || substring;
    }

    return result;
  }

  //

  let addOutput = "";

  if (newNewOutput !== "" && newNewOutput.length - 1 < min_elementCount * 4) {
    whatever: for (let a = 0; newNewOutput.length - 1 + addOutput.length - 1 <= min_elementCount * 4; a++) {
      for (let i = 0; i < min_elementCount * 4 - (newNewOutput.length - 1); i++) {
        addOutput += newNewOutput.substr(i, 1);
        if (newNewOutput.length - 1 + addOutput.length - 1 === min_elementCount * 4) {
          break whatever;
        }
      }
    }
  }

  newNewOutput += addOutput;

  return newNewOutput;
}

sketch.getFirstLetters = function(nameGoesHere, additionalNames) {
  const myString = nameGoesHere + " " + additionalNames;
  const words = myString.split(" ");
  const firstLetters = words.map((word) => word.charAt(0).toUpperCase());

  let result = "";
  const length = firstLetters.length;

  for (let i = 0; i < length; i++) {
    result += firstLetters[i];
  }

  return result;
}


// design elements

sketch.element003_0 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(turq_colour);

  sketch.push();
  sketch.rotate(15);
  sketch.rect(0, 0, (size / verhouding) * 0.8, (size / verhouding) * 0.8);
  sketch.pop();
  sketch.pop();
}
sketch.element003_1 = function(verhouding, plaatsX, plaatsY, size) {
  /*   let gradient_purple_pink2 = sketch.drawingContext.createLinearGradient(0 - size / 2, 0, 0 + size / 2, 0);

  gradient_purple_pink2.addColorStop(0, sketch.color(purple_colour));
  gradient_purple_pink2.addColorStop(1, sketch.color(pink_colour)); */

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(turq_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(brown_colour);

  sketch.push();

  sketch.rotate(15);

  //drawingContext.fillStyle = gradient_purple_pink2;
  sketch.rect(0, 0, (size / verhouding) * 0.8, (size / verhouding) * 0.8);
  sketch.pop();

  sketch.pop();
}

// - 008 binary quarter circle

// Hier gebruik ik allen 0 en 1
sketch.element008_3 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(brown_colour);
  sketch.arc(size / verhouding / 2, size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 180, 270);
  sketch.pop();
}
sketch.element008_4 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(brown_colour);
  sketch.arc(-size / verhouding / 2, -size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 0, 90);
  sketch.pop();
}
sketch.element008_2 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(brown_colour);
  sketch.arc(size / verhouding / 2, -size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 90, 180);
  sketch.pop();
}
sketch.element008_0 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(brown_colour);
  sketch.arc(-size / verhouding / 2, size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 270, 360);
  sketch.pop();
}
sketch.element008_1 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(pink_colour);
  sketch.arc(size / verhouding / 2, size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 180, 270);
  sketch.pop();
}
sketch.element008_5 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(pink_colour);
  sketch.arc(-size / verhouding / 2, -size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 0, 90);
  sketch.pop();
}
sketch.element008_6 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(pink_colour);
  sketch.arc(size / verhouding / 2, -size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 90, 180);
  sketch.pop();
}
sketch.element008_7 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(pink_colour);
  sketch.arc(-size / verhouding / 2, size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 270, 360);
  sketch.pop();
}
sketch.element008_8 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(pink_colour);
  sketch.arc(size / verhouding / 2, -size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 90, 180);
  sketch.pop();
}
sketch.element008_9 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(pink_colour);
  sketch.arc(-size / verhouding / 2, size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 270, 360);
  sketch.pop();
}
sketch.element008_10 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(brown_colour);
  sketch.arc(size / verhouding / 2, size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 180, 270);
  sketch.pop();
}
sketch.element008_11 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(brown_colour);
  sketch.arc(-size / verhouding / 2, -size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 0, 90);
  sketch.pop();
}
sketch.element008_12 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(brown_colour);
  sketch.arc(size / verhouding / 2, -size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 90, 180);
  sketch.pop();
}
sketch.element008_13 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(brown_colour);
  sketch.arc(-size / verhouding / 2, size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 270, 360);
  sketch.pop();
}
sketch.element008_14 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(pink_colour);
  sketch.arc(size / verhouding / 2, size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 180, 270);
  sketch.pop();
}
sketch.element008_15 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(pink_colour);
  sketch.arc(-size / verhouding / 2, -size / verhouding / 2, (size / verhouding) * 2, (size / verhouding) * 2, 0, 90);
  sketch.pop();
}

// - 09 BINARY HALF CIRCLE

sketch.element009_0 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);

  sketch.push();
  sketch.rotate(0);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.arc(0, size / verhouding / 2, size / verhouding, size / verhouding, 180, 0);
  sketch.pop();
}

sketch.element009_13 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);

  sketch.push();
  sketch.rotate(180);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.arc(0, size / verhouding / 2, size / verhouding, size / verhouding, 180, 0);
  sketch.pop();
}

sketch.element009_14 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);

  sketch.push();
  sketch.rotate(0);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.arc(0, -size / verhouding / 2, size / verhouding, size / verhouding, 0, 180);
  sketch.pop();
}

sketch.element009_12 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);

  sketch.push();
  sketch.rotate(180);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.arc(0, -size / verhouding / 2, size / verhouding, size / verhouding, 0, 180);
  sketch.pop();
}

sketch.element009_10 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.push();
  sketch.rotate(90);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
  sketch.fill(blue_colour);
  sketch.arc(size / verhouding / 2, 0, size / verhouding, size / verhouding, 90, 270);
  sketch.pop();
}

sketch.element009_5 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);
  sketch.push();
  sketch.rotate(270);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
  sketch.fill(blue_colour);
  sketch.arc(size / verhouding / 2, 0, size / verhouding, size / verhouding, 90, 270);
  sketch.pop();
}

sketch.element009_6 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);

  sketch.push();
  sketch.rotate(90);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.arc(-size / verhouding / 2, 0, size / verhouding, size / verhouding, 270, 90);
  sketch.pop();
}

sketch.element009_4 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(pink_colour);

  sketch.push();
  sketch.rotate(270);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.arc(-size / verhouding / 2, 0, size / verhouding, size / verhouding, 270, 90);
  sketch.pop();
}

sketch.element009_8 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  drawingContext.fillStyle = gradient_pink_yellow;
  ellipse(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
}

sketch.element009_9 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  scale(-1, 1);
  drawingContext.fillStyle = gradient_pink_yellow;
  ellipse(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
}

sketch.element009_7 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  drawingContext.fillStyle = gradient_pink_yellow;
  ellipse(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
}

sketch.element009_11 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  scale(-1, 1);
  drawingContext.fillStyle = gradient_pink_yellow;
  ellipse(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
}

sketch.element009_15 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.arc(size / verhouding / 2, 0, size / verhouding, size / verhouding, 90, 270);
  sketch.pop();
}

sketch.element009_1 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  scale(-1, 1);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.arc(size / verhouding / 2, 0, size / verhouding, size / verhouding, 90, 270);
  sketch.pop();
}

sketch.element009_2 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  scale(1, -1);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.arc(-size / verhouding / 2, 0, size / verhouding, size / verhouding, 270, 90);
  sketch.pop();
}

sketch.element009_3 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  scale(-1, -1);
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.arc(-size / verhouding / 2, 0, size / verhouding, size / verhouding, 270, 90);
  sketch.pop();
}

// 0-1 binary with half a circle + stripe
sketch.element010_0 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  /* sketch.push()
sketch.translate(plaatsX, plaatsY)
sketch.fill(pink_colour)
sketch.push()
sketch.rotate(90)
drawingContext.fillStyle = gradient_pink_yellow;
sketch.rect(0, 0, size / verhouding, size / verhouding)
sketch.pop()
sketch.fill(blue_colour)
sketch.rect(0,0,size/verhouding, size/verhouding/3)
sketch.pop() */

  sketch.fill(yellow_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(blue_colour);
  sketch.rect(0, -size / verhouding / 5, size / verhouding, size / verhouding / 4);
  sketch.rect(0, size / verhouding / 5, size / verhouding, size / verhouding / 4);
}

sketch.element010_1 = function(verhouding, plaatsX, plaatsY, size) {

  let colourA;

  if (input_data.personality.charAt(0) === "*") {
    colourA = orange_colour;
  } else {
    colourA = yellow_colour;
  }

  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  /*   sketch.fill(pink_colour)
  sketch.push()
  sketch.rotate(270)
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding)
  sketch.pop()
  sketch.fill(blue_colour)
  sketch.arc(size / verhouding / 2, 0, size / verhouding, size / verhouding, 90, 270) */

  //sketch.rotate(90)
  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(colourA);
  sketch.rect(0, -size / verhouding / 5, size / verhouding, size / verhouding / 4);
  sketch.rect(0, size / verhouding / 5, size / verhouding, size / verhouding / 4);

  sketch.pop();
}

//0-1 binary with rotated squares
sketch.element017_0 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();

  sketch.translate(plaatsX, plaatsY);
  sketch.fill(yellow_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.rotate(15);
  sketch.fill(purple_colour);
  sketch.rect(0, 0, (size / verhouding) * 0.81, (size / verhouding) * 0.81);
  sketch.pop();
}

sketch.element017_1 = function(verhouding, plaatsX, plaatsY, size) {
  if (input_data.personality.charAt(0) === "*") {
    colourA = orange_colour;
  } else {
    colourA = yellow_colour;
  }

  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  /*   sketch.fill(pink_colour)
  sketch.push()
  sketch.rotate(270)
  drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding)
  sketch.pop()
  sketch.fill(blue_colour)
  sketch.arc(size / verhouding / 2, 0, size / verhouding, size / verhouding, 90, 270) */

  //sketch.rotate(90)
  sketch.fill(orange_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.fill(colourA);
  sketch.rect(0, -size / verhouding / 5, size / verhouding, size / verhouding / 4);
  sketch.rect(0, size / verhouding / 5, size / verhouding, size / verhouding / 4);

  sketch.pop();
}

sketch.element017_1 = function(verhouding, plaatsX, plaatsY, size) {
  sketch.push();

  sketch.translate(plaatsX, plaatsY);
  sketch.fill(purple_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.rotate(15);
  sketch.fill(yellow_colour);
  sketch.rect(0, 0, (size / verhouding) * 0.81, (size / verhouding) * 0.81);
  sketch.pop();
}

// binary x2 with triangles

sketch.element011_0 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_13 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_14 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_12 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_10 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);
  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
  sketch.fill(blue_colour);
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_5 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);
  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_6 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_4 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_8 = function(verhouding, plaatsX, plaatsY, size) {
  //let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - (size / verhouding) / 2, 0, 0 + (size / verhouding) / 2, 0);
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_9 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(pink_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(yellow_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_7 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(pink_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(yellow_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_11 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(pink_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(yellow_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_15 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_1 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_2 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element011_3 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(blue_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

// andere kleur voor 12

sketch.element012_0 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_13 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_14 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_12 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_5 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_4 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_10 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_6 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(brown_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_8 = function(verhouding, plaatsX, plaatsY, size) {
  //let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - (size / verhouding) / 2, 0, 0 + (size / verhouding) / 2, 0);
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_9 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(white_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(yellow_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_7 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_11 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(white_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(yellow_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(0, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, 0);
  sketch.vertex(0, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_15 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(0, 0);
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_1 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_2 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.fill(brown_colour);
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(size / verhouding / 2, size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

sketch.element012_3 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(white_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.beginShape();
  sketch.vertex(size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(-size / verhouding / 2, -size / verhouding / 2);
  sketch.vertex(0, 0);
  sketch.endShape(sketch.CLOSE);
  sketch.pop();
}

// binary x2 with squares in corners

sketch.element013_0 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(-size / verhouding / 4, size / verhouding / 4, size / verhouding / 2, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_13 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(-size / verhouding / 4, -size / verhouding / 4, size / verhouding / 2, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_14 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(size / verhouding / 4, size / verhouding / 4, size / verhouding / 2, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_12 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(-size / verhouding / 4, size / verhouding / 4, size / verhouding / 2, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_5 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(-size / verhouding / 4, size / verhouding / 4, size / verhouding / 2, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_4 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(-size / verhouding / 4, -size / verhouding / 4, size / verhouding / 2, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_10 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(size / verhouding / 4, size / verhouding / 4, size / verhouding / 2, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_6 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(size / verhouding / 4, -size / verhouding / 4, size / verhouding / 2, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_8 = function(verhouding, plaatsX, plaatsY, size) {
  //let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - (size / verhouding) / 2, 0, 0 + (size / verhouding) / 2, 0);
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
  sketch.pop();
}

sketch.element013_9 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(pink_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(yellow_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
  sketch.pop();
}

sketch.element013_7 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
  sketch.pop();
}

sketch.element013_11 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(pink_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(yellow_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();
  sketch.pop();
}

sketch.element013_15 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(0, -size / verhouding / 4, size / verhouding, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_1 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(0, -size / verhouding / 4, size / verhouding, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_2 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(0, size / verhouding / 4, size / verhouding, size / verhouding / 2);
  sketch.pop();
}

sketch.element013_3 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(0, size / verhouding / 4, size / verhouding, size / verhouding / 2);
  sketch.pop();
}

// binary x2 with /4 LINES

sketch.element014_0 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(-size / verhouding / 2 + size / verhouding / 8, 0, size / verhouding / 4, size / verhouding);
  sketch.pop();
}

sketch.element014_13 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(size / verhouding / 2 - size / verhouding / 8, 0, size / verhouding / 4, size / verhouding);
  sketch.pop();
}

sketch.element014_14 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(-size / verhouding / 2 + size / verhouding / 8, 0, size / verhouding / 4, size / verhouding);
  sketch.pop();
}

sketch.element014_12 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(size / verhouding / 2 - size / verhouding / 8, 0, size / verhouding / 4, size / verhouding);
  sketch.pop();
}

sketch.element014_5 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);

  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(-size / verhouding / 2 + size / verhouding / 8, 0, size / verhouding / 4, size / verhouding);
  sketch.pop();
}

sketch.element014_4 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);

  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(size / verhouding / 2 - size / verhouding / 8, 0, size / verhouding / 4, size / verhouding);
  sketch.pop();
}

sketch.element014_10 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);

  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(-size / verhouding / 2 + size / verhouding / 8, 0, size / verhouding / 4, size / verhouding);
  sketch.pop();
}

sketch.element014_6 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);

  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(size / verhouding / 2 - size / verhouding / 8, 0, size / verhouding / 4, size / verhouding);
  sketch.pop();
}

sketch.element014_8 = function(verhouding, plaatsX, plaatsY, size) {
  //let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - (size / verhouding) / 2, 0, 0 + (size / verhouding) / 2, 0);
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(0, size / verhouding / 2 - size / verhouding / 8, size / verhouding, size / verhouding / 4);
  sketch.pop();
}

sketch.element014_9 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(pink_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(yellow_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(0, size / verhouding / 2 - size / verhouding / 8, size / verhouding, size / verhouding / 4);
  sketch.pop();
}

sketch.element014_7 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(0, -size / verhouding / 2 + size / verhouding / 8, size / verhouding, size / verhouding / 4);
  sketch.pop();
}

sketch.element014_11 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(pink_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(yellow_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(brown_colour);
  sketch.rect(0, -size / verhouding / 2 + size / verhouding / 8, size / verhouding, size / verhouding / 4);
  sketch.pop();
}

sketch.element014_15 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, -size / verhouding / 2 + size / verhouding / 8, size / verhouding, size / verhouding / 4);
  sketch.pop();
}

sketch.element014_1 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, -size / verhouding / 2 + size / verhouding / 8, size / verhouding, size / verhouding / 4);
  sketch.pop();
}

sketch.element014_2 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, size / verhouding / 2 - size / verhouding / 8, size / verhouding, size / verhouding / 4);
  sketch.pop();
}

sketch.element014_3 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);

  sketch.push();
  sketch.rotate(180);
  sketch.fill(brown_colour);
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, size / verhouding / 2 - size / verhouding / 8, size / verhouding, size / verhouding / 4);
  sketch.pop();
}

// binary x2 with double gradient /4 LINES

sketch.element015_0 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, 0, size / verhouding, size / verhouding / 3);
  sketch.pop();
}

sketch.element015_13 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, 0, size / verhouding, size / verhouding / 3);
  sketch.pop();
}

sketch.element015_14 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, 0, size / verhouding, size / verhouding / 3);
  sketch.pop();
}

sketch.element015_12 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, 0, size / verhouding, size / verhouding / 3);
  sketch.pop();
}

sketch.element015_5 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, size / verhouding / 2 - size / verhouding / 6, size / verhouding, size / verhouding / 3);
  sketch.pop();
}

sketch.element015_4 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, -size / verhouding / 2 + size / verhouding / 6, size / verhouding, size / verhouding / 3);
  sketch.pop();
}

sketch.element015_10 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, size / verhouding / 2 - size / verhouding / 6, size / verhouding, size / verhouding / 3);
  sketch.pop();
}

sketch.element015_6 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, -size / verhouding / 2 + size / verhouding / 6, size / verhouding, size / verhouding / 3);
  sketch.pop();
}

sketch.element015_8 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.push();
  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, 0, size / verhouding / 3, size / verhouding);
  sketch.pop();
  sketch.pop();
}

sketch.element015_9 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, 0, size / verhouding / 3, size / verhouding);
  sketch.pop();
}

sketch.element015_7 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, 0, size / verhouding / 3, size / verhouding);
  sketch.pop();
}

sketch.element015_11 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(0, 0, size / verhouding / 3, size / verhouding);
  sketch.pop();
}

sketch.element015_15 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(-size / verhouding / 2 + size / verhouding / 6, 0, size / verhouding / 3, size / verhouding);
  sketch.pop();
}

sketch.element015_1 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(size / verhouding / 2 - size / verhouding / 6, 0, size / verhouding / 3, size / verhouding);
  sketch.pop();
}

sketch.element015_2 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(size / verhouding / 2 - size / verhouding / 6, 0, size / verhouding / 3, size / verhouding);
  sketch.pop();
}

sketch.element015_3 = function(verhouding, plaatsX, plaatsY, size) {
  let gradient_pink_yellow = sketch.drawingContext.createLinearGradient(0 - size / verhouding / 2, 0, 0 + size / verhouding / 2, 0);

  gradient_pink_yellow.addColorStop(0, sketch.color(yellow_colour));
  gradient_pink_yellow.addColorStop(1, sketch.color(pink_colour));

  let gradient_orange_blue = sketch.drawingContext.createLinearGradient(0, 0 - size / verhouding / 2, 0, 0 + size / verhouding / 2);

  gradient_orange_blue.addColorStop(0, sketch.color(orange_colour));
  gradient_orange_blue.addColorStop(1, sketch.color(blue_colour));

  sketch.push();
  sketch.translate(plaatsX, plaatsY);
  sketch.fill(blue_colour);

  sketch.push();
  sketch.rotate(0);
  sketch.drawingContext.fillStyle = gradient_pink_yellow;
  sketch.rect(0, 0, size / verhouding, size / verhouding);
  sketch.pop();

  sketch.fill(blue_colour);
  sketch.drawingContext.fillStyle = gradient_orange_blue;
  sketch.rect(-size / verhouding / 2 + size / verhouding / 6, 0, size / verhouding / 3, size / verhouding);
  sketch.pop();
}



      // SAVE PNG

      sketch.keyTyped = function () {
        if (sketch.key === '=') {
          sketch.saveCanvas('P12.png');

        }

      }

    }, container1);

    p5Instance2 = new p5((sketch) => {

      // Variables:

      let data;
      let myOutput;

      //colours
      let purple_colour = '#670099'
      let blue_colour = '#3e51ff'
      let pink_colour = 'hotpink'
      let turq_colour = 'aqua'
      let orange_colour = '#FF4500'
      let brown_colour = '#640045'
      let yellow_colour = '#f5bf00'
      let white_colour = 'white'
      let black_colour = 'black'

      sketch.setup = () => {

        sketch.createCanvas(p5Width, p5Height); // Create a 512x512 texture
        sketch.background(brown_colour);

      };

      sketch.draw = () => {
        sketch.background(brown_colour);

        // Set the flag to true after first draw
        if (!p5Instance2Ready) {
          p5Instance2Ready = true;
          checkIfReady();
        }
      };

    }, container2);

  });
}